import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵelement, ɵɵpipe, ɵɵnextContext, ɵɵproperty, ɵɵpipeBind2, ɵɵsanitizeHtml, ɵɵgetCurrentView, ɵɵelementStart, ɵɵlistener, ɵɵrestoreView, ɵɵtemplate, ɵɵtext, ɵɵelementEnd, ɵɵclassProp, ɵɵadvance, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵsanitizeUrl, ɵɵsanitizeResourceUrl, ɵɵnamespaceSVG, ɵɵnamespaceHTML, EventEmitter, ɵɵdirectiveInject, ɵɵdefineComponent, Component, Input, Output, ɵɵpureFunction1, ɵɵtextInterpolate1, ɵɵtextInterpolate, ɵɵdefinePipe, Pipe, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { HttpService, PathService } from '@akeela/properties';
import { ActivatedRoute, Router } from '@angular/router';
import { mergeMap, map } from 'rxjs/operators';
import { isNullOrUndefined, isUndefined } from 'util';
import { __awaiter } from 'tslib';
import { HttpClient, HttpRequest, HttpEventType } from '@angular/common/http';
import { I18nPipe, I18nModule } from '@akeela/i18n';
import swal from 'sweetalert2';
import { AlertService } from '@akeela/alert';
import { LocalService } from '@akeela/local-storage';
import { DomSanitizer } from '@angular/platform-browser';
import { NgIf, DatePipe, NgForOf, CommonModule } from '@angular/common';
import { ImageViewerComponent, ImageViewerModule } from 'ngx-image-viewer';
import { WebcamUtil, WebcamComponent as WebcamComponent$1, WebcamModule } from 'ngx-webcam';
import { NgxDocViewerComponent, NgxDocViewerModule } from 'ngx-doc-viewer2';

class CreditService {
    constructor(_httpService, route, router) {
        this._httpService = _httpService;
        this.route = route;
        this.router = router;
        this.role$ = new BehaviorSubject(null);
        this.audience$ = new BehaviorSubject(null);
        this.profile$ = new BehaviorSubject(null);
        this.figure$ = new BehaviorSubject('ACCREDITED');
    }
    setCreditRole(value) {
        this.role$.next(value);
    }
    setCreditAudience(value) {
        this.audience$.next(value);
    }
    setCreditProfile(value) {
        this.profile$.next(value);
    }
    setFigure(value) {
        localStorage.setItem("figure", value);
        this.figure$.next(value);
    }
    get figure() {
        this.route.params
            .pipe(mergeMap(params => this.route.queryParams
            .pipe(map(queryParams => {
            return Object.assign(Object.assign({}, params), queryParams);
        }))))
            .subscribe(params => {
            if (params.figure) {
                this.setFigure(params.figure);
                localStorage.setItem("figure", params.figure);
            }
            else if (localStorage.getItem("figure")) {
                this.setFigure(localStorage.getItem("figure"));
            }
            ;
        });
        return this.figure$;
    }
}
/** @nocollapse */ CreditService.ɵfac = function CreditService_Factory(t) { return new (t || CreditService)(ɵɵinject(HttpService), ɵɵinject(ActivatedRoute), ɵɵinject(Router)); };
/** @nocollapse */ CreditService.ɵprov = ɵɵdefineInjectable({ token: CreditService, factory: CreditService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CreditService, [{
        type: Injectable
    }], function () { return [{ type: HttpService }, { type: ActivatedRoute }, { type: Router }]; }, null); })();

const lang = {
    "@i18n-client-onBoarding-title": " Solicita Ahora!<br> tú crédito Online",
    "@i18n-client-onBoarding-subTitle": " Tu Préstamo, para lo que quieras, así de fácil.",
    "@i18n-client-onBoarding-content": "<br> ¿Te imaginas obtener un préstamo de forma rápida y sencilla cuando lo necesites? ¿Te gustaría disfrutar rápidamente tu préstamo? Nosotros nos ajustamos a tus necesidades… <br><br> ¡Si lo quieres, lo tienes!",
    "@i18n-client-onBoarding-btn": "Solicitar Crédito",
    "@i18n-footer-copyright": "Todos los derechos reservados",
    "@i18n-footer-privacity": "privacidad",
    "@i18n-footer-legalagreements": "acuerdos legales",
    "@i18n-footer-contact": "contacto",
    "@i18n-footer-opinion": "opinión",
    "@i18n-datatable-nodata": "SIN DATA",
    "@i18n-menudropdown-export": "exportar a excel",
    "@i18n-menudropdown-print": "imprimir",
    "@i18n-app-column-num-formalities": "Tramite",
    "@i18n-app-column-product": "Producto",
    "@i18n-app-column-plan": "Plan",
    "@i18n-app-column-amount": "Monto",
    "@i18n-app-column-module": "Modulo",
    "@i18n-app-column-next-step": "Próximo Paso",
    "@i18n-app-column-status": "Estatus",
    "@i18n-app-column-description": "Descripcion",
    "@i18n-app-column-update-date": "Última actualización",
    "@i18n-app-column-detail": "",
    "@i18n-table-column-period": "Periodo",
    "@i18n-table-column-file": "Archivo",
    "@i18n-table-column-update-date": "Última actualización",
    "@i18n-table-column-file-option": "",
    "@i18n-table-column-detail": "",
    "@i18n-table-column-bank": "Banco",
    "@i18n-table-column-number-account": "sro de Cuenta",
    "@i18n-table-column-owner": "Titular",
    "@i18n-table-column-delete": "",
    "@i18n-popup-confirm-title-answer": "Error",
    "@i18n-popup-confirm-title-success": "Éxito",
    "@i18n-popup-text-file-upload-error": "El archivo no se pudo subir al servidor.",
    "@i18n-popup-text-file-delete-error": "No se pudo eliminar el elemento",
    "@i18n-popup-text-file-delete-success": "Archivo eliminado.",
    "@i18n-popup-text-delete-question": "¿Estás seguro(a)?",
    "@i18n-popup-text-file-delete-question-text": "Una vez que se elimine, ¡No podrá recuperar este archivo!",
    "@i18n-popup-text-file-delete-question-button-yes": "Si, eliminar!",
    "@i18n-popup-text-file-delete-question-button-no": "No, cancelar!",
    "@i18n-popup-text-delete-question-text": "Una vez que se elimine, ¡No podrá recuperar esta información!",
    "@i18n-popup-text-yes": "Si",
    "@i18n-popup-text-no": "No",
    "@i18n-month-january": "Enero",
    "@i18n-month-february": "Febrero",
    "@i18n-month-march": "Marzo",
    "@i18n-month-april": "Abril",
    "@i18n-month-may": "Mayo",
    "@i18n-month-june": "Junio",
    "@i18n-month-july": "Julio",
    "@i18n-month-august": "Agosto",
    "@i18n-month-september": "Septiembre",
    "@i18n-month-october": "Octubre",
    "@i18n-month-november": "Noviembre",
    "@i18n-month-december": "Diciembre",
    "@i18n-text-complete": "Completo",
    "@i18n-text-incomplete": "Incompleto",
    "@i18n-text-please-wait": "Por favor, espere",
    "@i18n-text-downloading-file": "Descargando archivo",
    "@i18n-text-success": "Exito",
    "@i18n-text-error": "Error",
    "@i18n-text-information-deleted": "Información eliminada",
    "@i18n-text-information-not-deleted": "Información no pudo ser eliminada",
    "@i18n-text-choose-a-file": "Seleccionar...",
    "@i18n-text-accredited": "Acreditado",
    "@i18n-text-guarantor": "Aval",
    "@i18n-text-accept": "Aceptar",
    "@i18n-text-role": "Rol",
    "@i18n-text-next": "Siguiente",
    "@i18n-text-continue": "Continuar",
    "@i18n-text-client-type": "Tipo de cliente",
    "@i18n-text-operation-data": "Datos de la Operación",
    "@i18n-text-see-amortization-table": "Cronograma de pago",
    "@i18n-text-review": "Resumen",
    "@i18n-text-terms-and-conditions": "Terminos y condiciones",
    "@i18n-text-required": "Requerido",
    "@i18n-store-front-steps-text-create-account-user": "Crear perfil del solicitante"
};

const lang$1 = {
    '@i18n-client-onBoarding-title': 'Apply Now!<br> Your Credit Online',
    '@i18n-client-onBoarding-subTitle': 'Your loan, for whatever you want, that easy.',
    '@i18n-client-onBoarding-content': '<br> Can you imagine getting a loan quickly and easily when you need it? Would you like to enjoy your loan quickly? We adjust to your needs <br><br>If you want it, you have it!',
    '@i18n-client-onBoarding-btn': 'Apply',
    '@i18n-footer-copyright': 'All rights reserved',
    '@i18n-footer-privacity': 'privacity',
    '@i18n-footer-legalagreements': 'legal agreements',
    '@i18n-footer-contact': 'contact',
    '@i18n-footer-opinion': 'opinion',
    '@i18n-datatable-nodata': 'NO DATA',
    '@i18n-menudropdown-export': 'export to excel',
    '@i18n-menudropdown-csv': 'export to .csv',
    '@i18n-menudropdown-print': 'print',
    '@i18n-app-column-num-formalities': 'Procedure',
    '@i18n-app-column-product': 'Product',
    '@i18n-app-column-plan': 'Plan',
    '@i18n-app-column-amount': 'Amount',
    '@i18n-app-column-module': 'Module',
    '@i18n-app-column-next-step': 'Next step',
    '@i18n-app-column-status': 'Status',
    '@i18n-app-column-description': 'Description',
    '@i18n-app-column-update-date': 'Last actualization',
    '@i18n-app-column-detail': '',
    '@i18n-table-column-delete': '',
    '@i18n-popup-confirm-title-answer': 'Error',
    '@i18n-popup-confirm-title-success': 'Success',
    '@i18n-popup-text-file-upload-error': 'The file could not be uploaded to the server.',
    '@i18n-popup-text-file-delete-error': 'Error deleting the item',
    '@i18n-popup-text-file-delete-success': 'File deleted!.',
    '@i18n-popup-text-delete-question': 'Are you sure?',
    '@i18n-popup-text-file-delete-question-text': 'Once deleted, you will not be able to recover this file!',
    '@i18n-popup-text-file-delete-question-button-yes': 'Yes, delete it!',
    '@i18n-popup-text-file-delete-question-button-no': 'No, cancel!',
    '@i18n-popup-text-delete-question-text': 'Once it is deleted, you will not be able to retrieve this information!',
    '@i18n-popup-text-yes': 'Yes',
    '@i18n-popup-text-no': 'No',
    '@i18n-month-january': 'January',
    '@i18n-month-february': 'February',
    '@i18n-month-march': 'March',
    '@i18n-month-april': 'April',
    '@i18n-month-may': 'May',
    '@i18n-month-june': 'June',
    '@i18n-month-july': 'July',
    '@i18n-month-august': 'August',
    '@i18n-month-september': 'September',
    '@i18n-month-october': 'October',
    '@i18n-month-november': 'November',
    '@i18n-month-december': 'December',
    '@i18n-text-complete': 'Complete',
    '@i18n-text-incomplete': 'Incomplete',
    '@i18n-text-please-wait': 'Please, wait',
    '@i18n-text-downloading-file': 'Downloading file',
    '@i18n-text-success': 'Success',
    '@i18n-text-error': 'Error',
    '@i18n-text-information-deleted': 'Information deleted',
    '@i18n-text-information-not-deleted': 'Information could not be deleted',
    '@i18n-text-choose-a-file': 'Choose a file...'
};

class I18nService {
    constructor() {
        this.languages = {};
        this.lang_default = 'es';
        this.langDefault = 'es';
        this.lang = this.langDefault;
        this.generateLang();
    }
    add(lang, lang_id) {
        if (isNullOrUndefined(this.languages[lang_id]))
            this.languages[lang_id] = {};
        this.languages[lang_id] = Object.assign(this.languages[lang_id], lang);
    }
    generateLang() {
        this.add(lang, 'es');
        this.add(lang$1, 'en');
    }
    set langDefault(lang_default) {
        this.lang_default = lang_default;
    }
    getLangJson(langId) {
        if (isNullOrUndefined(this.languages[langId]))
            langId = this.langDefault;
        return this.languages[langId];
    }
}
/** @nocollapse */ I18nService.ɵfac = function I18nService_Factory(t) { return new (t || I18nService)(); };
/** @nocollapse */ I18nService.ɵprov = ɵɵdefineInjectable({ token: I18nService, factory: I18nService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(I18nService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class CommonService {
    constructor() {
        this.workspaceCode$ = new BehaviorSubject(null);
    }
    setWorkspaceCode(value) {
        this.workspaceCode$.next(value);
    }
}
/** @nocollapse */ CommonService.ɵfac = function CommonService_Factory(t) { return new (t || CommonService)(); };
/** @nocollapse */ CommonService.ɵprov = ɵɵdefineInjectable({ token: CommonService, factory: CommonService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CommonService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class VisorService {
    constructor() {
        this.change$ = new BehaviorSubject([]);
        this.isActive$ = new BehaviorSubject(false);
    }
}
/** @nocollapse */ VisorService.ɵfac = function VisorService_Factory(t) { return new (t || VisorService)(); };
/** @nocollapse */ VisorService.ɵprov = ɵɵdefineInjectable({ token: VisorService, factory: VisorService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(VisorService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class PaginatorService {
    constructor() {
        this.getPaginatorFrom = (paginator, config) => paginator.totalPages > 0 ? (paginator.pageable.pageNumber) * config.paginator.size + 1 : 0;
        this.getPaginatorTo = (paginator, config) => paginator.pageable.to = (((paginator.pageable.pageNumber + 1) * config.paginator.size) < paginator.number) ? ((paginator.pageable.pageNumber + 1) * config.paginator.size) : paginator.number;
        this.getDataPaginator = (paginator, config, data) => {
            let aux = [];
            const temp = ((paginator.pageable.pageNumber + 1) * config.paginator.size);
            const number = temp < (data === null || data === void 0 ? void 0 : data.length) ? temp : data === null || data === void 0 ? void 0 : data.length;
            for (let i = (paginator.pageable.pageNumber) * config.paginator.size; i < number; i++) {
                aux = [...aux, data[i]];
            }
            return aux;
        };
    }
}
/** @nocollapse */ PaginatorService.ɵfac = function PaginatorService_Factory(t) { return new (t || PaginatorService)(); };
/** @nocollapse */ PaginatorService.ɵprov = ɵɵdefineInjectable({ token: PaginatorService, factory: PaginatorService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PaginatorService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class FileService {
    constructor(http, _path, httpService) {
        this.http = http;
        this._path = _path;
        this.httpService = httpService;
        this.getArchive = (identifier) => __awaiter(this, void 0, void 0, function* () {
            const params = {
                name: 'archive$archive$get',
                params: {
                    request: {
                        identifierArchive: identifier
                    },
                    body: {}
                }
            };
            return yield this.httpService.executeRequest(params.name, params.params, true).toPromise();
        });
    }
    getFile(identifier, contentDisposition, name, endpoint) {
        return new Observable(resolve => {
            this._path.getPathService(endpoint).subscribe((resp) => {
                const url = resp.url;
                return this.http
                    .get(url + '?idArchive=' + identifier + '&contentDisposition=' + contentDisposition, {
                    responseType: 'blob',
                    observe: 'response'
                }).pipe(map(response => {
                    const contentType = response.body.type;
                    const blob = new Blob([response.body, name], { type: contentType });
                    const data = {
                        blob: blob,
                        type: contentType,
                        name: name,
                        content: contentDisposition,
                        contentDisposition: contentDisposition + '; filename="' + name + '"'
                    };
                    return data;
                }))
                    .subscribe(resultado => {
                    console.log(resultado);
                    resolve.next(resultado);
                    resolve.complete();
                }, (error) => {
                    resolve.error(error);
                });
            });
        });
    }
}
/** @nocollapse */ FileService.ɵfac = function FileService_Factory(t) { return new (t || FileService)(ɵɵinject(HttpClient), ɵɵinject(PathService), ɵɵinject(HttpService)); };
/** @nocollapse */ FileService.ɵprov = ɵɵdefineInjectable({ token: FileService, factory: FileService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FileService, [{
        type: Injectable
    }], function () { return [{ type: HttpClient }, { type: PathService }, { type: HttpService }]; }, null); })();

class CountdownService {
    constructor() {
        this.current_time = null;
        this.deadline = null;
        this.time = null;
    }
    time_remaining(endDate) {
        const t = Date.parse(endDate) - Date.parse((new Date()).toString());
        const seconds = Math.floor((t / 1000) % 60);
        const minutes = Math.floor((t / 1000 / 60) % 60);
        const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        const days = Math.floor(t / (1000 * 60 * 60 * 24));
        this.time = { 'total': t, 'days': days, 'hours': hours, 'minutes': minutes.toString().padStart(2, '0'), 'seconds': seconds.toString().padStart(2, '0') };
    }
    run_clock(time_in_minutes, date = null) {
        this.current_time = Date.parse((new Date()).toString());
        if (date !== null) {
            this.deadline = new Date(Date.parse(date) + time_in_minutes * 60 * 1000);
        }
        else {
            this.deadline = new Date(this.current_time + time_in_minutes * 60 * 1000);
        }
        return new Promise((resolve, reject) => {
            this.time_remaining(this.deadline);
            const timeinterval = setInterval(() => {
                if (this.time.total > 0) {
                    this.time_remaining(this.deadline);
                }
                else {
                    resolve(true);
                }
            }, 500);
        });
    }
}
/** @nocollapse */ CountdownService.ɵfac = function CountdownService_Factory(t) { return new (t || CountdownService)(); };
/** @nocollapse */ CountdownService.ɵprov = ɵɵdefineInjectable({ token: CountdownService, factory: CountdownService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CountdownService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class UtilsService {
    constructor(i18n, http) {
        this.i18n = i18n;
        this.http = http;
    }
    extractJSON(text, decod) {
        switch (decod) {
            case 'DECOD1':
                return JSON.parse(this.decod1(text));
            default:
                return '';
        }
    }
    digestI18n(text, character) {
        let retorno = '';
        if (!isNullOrUndefined(text)) {
            const aux = text.split(character);
            if (!isNullOrUndefined(aux)) {
                for (let i = 0; i < aux.length; i++) {
                    const texto = aux[i];
                    if (aux[i].startsWith('@i18n')) {
                        if (aux.length === 1) {
                            retorno = this.i18n.transform(texto);
                        }
                        else {
                            retorno = retorno + ' ' + this.i18n.transform(texto) + ' ';
                        }
                    }
                    else {
                        retorno = retorno + this.i18n.transform(texto);
                    }
                }
            }
            else {
                retorno = text;
            }
        }
        else {
            retorno = text;
        }
        return retorno;
    }
    decod1(text) {
        text = text.replace(new RegExp('{', 'g'), '{"');
        text = text.replace(new RegExp('],', 'g'), '#####');
        text = text.replace(new RegExp('\\[', 'g'), '["');
        text = text.replace(new RegExp('=', 'g'), '":');
        text = text.replace(new RegExp(',', 'g'), '","');
        text = text.replace(new RegExp('#####', 'g'), '"],"');
        text = text.replace(new RegExp(']}', 'g'), '"]}');
        return text;
    }
    getIPAddress() {
        return new Promise((resolve) => {
            this.http.get('https://api.ipify.org/?format=json').subscribe((res) => {
                resolve(res.ip);
            }, error => {
                resolve(null);
            });
        });
    }
}
/** @nocollapse */ UtilsService.ɵfac = function UtilsService_Factory(t) { return new (t || UtilsService)(ɵɵinject(I18nPipe), ɵɵinject(HttpClient)); };
/** @nocollapse */ UtilsService.ɵprov = ɵɵdefineInjectable({ token: UtilsService, factory: UtilsService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UtilsService, [{
        type: Injectable
    }], function () { return [{ type: I18nPipe }, { type: HttpClient }]; }, null); })();

class ErrorService {
    constructor(i18n, alert, _utils) {
        this.i18n = i18n;
        this.alert = alert;
        this._utils = _utils;
        this.blacklist = ['@i18n-error-title-both-flags-null', '@i18n-error-message-ihnrc-null', '@i18n-error-title-both-flags-null', '@i18n-error-message-both-flags-null'];
    }
    validateLevelTwo(error) {
        if (!isNullOrUndefined(error.error)) {
            if (this.blacklist.indexOf(error.error.titleLabel) === -1 && this.blacklist.indexOf(error.error.messageLabel) === -1) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    }
    show(error, title_msg, default_msg) {
        if (!isNullOrUndefined(error)) {
            if (this.validateLevelTwo(error) && this.blacklist.indexOf(error.titleLabel) === -1 && this.blacklist.indexOf(error.messageLabel) === -1) {
                let msj = null;
                let status = null;
                if (!isNullOrUndefined(error)) {
                    if (error.status) {
                        status = error.status;
                    }
                    if (!isNullOrUndefined(error.error)) {
                        error = error.error;
                        if (error.status) {
                            status = error.status;
                        }
                    }
                    msj = this.error_text(error, status);
                }
                else {
                    msj = {
                        title: '',
                        html: ''
                    };
                }
                this.alert.show({
                    title: title_msg ? this.i18n.transform(title_msg) : msj.title,
                    html: default_msg ? this.i18n.transform(default_msg) : (msj.html),
                });
            }
        }
    }
    error_text(error, status) {
        let html = '';
        const digest_error = {
            title: '',
            html: ''
        };
        console.log('STATUSSSS');
        console.log(status);
        switch (status) {
            case 500 || '500':
                digest_error.title = this.i18n.transform('@i18n-error-somethings-wrong');
                digest_error.html = this.catch_error_code(error);
                break;
            case 401 || '401':
                digest_error.title = this.i18n.transform('@i18n-error-user-unauthorized');
                digest_error.html = this.catch_error_code(error);
                break;
            case 400 || '400':
                digest_error.title = (!isNullOrUndefined(error.titleLabel) && error.titleLabel !== '') ? this.i18n.transform(error.titleLabel) : this.i18n.transform('@i18n-error-bad-request');
                digest_error.html = this.catch_error_code(error);
                break;
            case 403 || '403':
                digest_error.title = (!isNullOrUndefined(error.titleLabel) && error.titleLabel !== '') ? this.i18n.transform(error.titleLabel) : this.i18n.transform('@i18n-error-server-internal-error');
                digest_error.html = this.catch_error_code(error);
                break;
            case 0 || '0':
                digest_error.title = this.i18n.transform('@i18n-error-server-internal-error');
                html += '<div class="pull-left" style="font-size:16px;text-align:center">';
                html += '' + this.i18n.transform('@i18n-error-unexpected-error') + '<br>';
                html += '</div>';
                digest_error.html = html;
                break;
            default:
                digest_error.title = this.i18n.transform('@i18n-error-server-internal-error');
                digest_error.html = this.catch_error_code(error);
                break;
        }
        return digest_error;
    }
    getDataDictionary(text) {
        switch (text) {
            case 'You missed his second attempt to login, the third failed attempt the user will be blocked':
                return this.i18n.transform('@i18n-error-missed-his-second-attempt-login');
            case 'Invalid email supplied':
                return this.i18n.transform('@i18n-error-invalid-email-suplied');
            case 'Invalid username supplied':
                return this.i18n.transform('@i18n-error-invalid-username-suplied');
            case 'The user has already logged in':
                return this.i18n.transform('@i18n-error-user-has-already-login');
            case 'The user has already logged in':
                return this.i18n.transform('@i18n-error-user-has-already-login');
            case 'the user is not locked':
                return this.i18n.transform('@i18n-error-user-is-not-locked');
            case 'the user is locked and requires manual unlocking':
                return this.i18n.transform('@i18n-error-user-is-locked-and-required-manual-unlocking');
            case 'the user exceed the fails attents recovery and is locked, requires manual unlocking':
                return this.i18n.transform('@i18n-error-user-exceed-fails-is-locked-and-required-manual-unlocking');
            default:
                return text;
        }
    }
    catch_error_code(error) {
        let html = '';
        switch (error.code) {
            case 'AKC-001':
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
            case 'AKC-002':
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
            case 'AKC-003':
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
            case 'AKC-004':
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
            case 'AKC-005':
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
            case 'AKC-006':
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
            case 'AKC-007':
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
            case 'AKC-008':
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                else if (!isNullOrUndefined(error.titleLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.titleLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
            case 'AKC-009':
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
            case 'AKC-010':
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
            case 'AKC-011':
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
            case 'AKC-012':
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
            case 'AKC-013':
                html += '<div class="" style="font-size:16px;text-align:left">';
                if (error.messageLabel) {
                    html += '<label>' + error.messageLabel + '</label>';
                }
                else {
                    html += '<label>' + this.i18n.transform('@i18n-error-bad-request-label') + '</label>';
                }
                const json = this._utils.extractJSON(error.message, 'DECOD1');
                for (const i of Object.keys(json)) {
                    html += '<div style="padding-left:12px">';
                    for (const j of json[i]) {
                        html += '-' + this._utils.digestI18n(this.getDataDictionary(j), '|') + '<br>';
                    }
                    html += '</div>';
                }
                html += '</div>';
                break;
            default:
                html += '<div class="" style="font-size:16px;text-align:center">';
                if (!isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.message, '|'))) + '<br>';
                }
                if (!isNullOrUndefined(error.messageLabel) && isNullOrUndefined(error.message)) {
                    html += '' + this.getDataDictionary(this.i18n.transform(this._utils.digestI18n(error.messageLabel, '|'))) + '<br>';
                }
                html += '</div>';
                break;
        }
        return html;
    }
}
/** @nocollapse */ ErrorService.ɵfac = function ErrorService_Factory(t) { return new (t || ErrorService)(ɵɵinject(I18nPipe), ɵɵinject(AlertService), ɵɵinject(UtilsService)); };
/** @nocollapse */ ErrorService.ɵprov = ɵɵdefineInjectable({ token: ErrorService, factory: ErrorService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ErrorService, [{
        type: Injectable
    }], function () { return [{ type: I18nPipe }, { type: AlertService }, { type: UtilsService }]; }, null); })();

class UploadService {
    constructor(_error, file, _i18n, _path, _http, localStorage) {
        this._error = _error;
        this.file = file;
        this._i18n = _i18n;
        this._path = _path;
        this._http = _http;
        this.localStorage = localStorage;
        this.files = [];
        this.exportFiles = new Subject();
        this.changeDataFile = new Subject();
        this.changeDataFileArr = new Subject();
        this.updateVisor = new Subject();
        this.change = new Subject();
        this.response = new Subject();
        this.visor = false;
        this.visor_params = {
            name: null,
            date: null,
            blob: null
        };
        this._next = null;
        this._back = null;
        this._visorFiles = null;
    }
    getChangesFiles() {
        return this.changeDataFile.asObservable();
    }
    getChangresFilesArr() {
        return this.changeDataFileArr.asObservable();
    }
    setChangesFiles() {
        this.changeDataFile.next(true);
    }
    setChangesFilesArr(files) {
        this.changeDataFileArr.next(files);
    }
    setUpdateVisor() {
        this.updateVisor.next(true);
    }
    getUpdateVisor() {
        return this.updateVisor.asObservable();
    }
    getResponseUpload() {
        return this.response.asObservable();
    }
    resetResponseUpload() {
        this.response.next(null);
    }
    setResponseUpload(response) {
        this.response.next(response);
    }
    resetChangeRequirementById() {
        this.change.next(null);
    }
    getChangeRequirementById() {
        return this.change.asObservable();
    }
    setChangeRequirementById(idRequirement) {
        this.change.next(idRequirement);
    }
    postFile(file, identifier, viewName, base_64) {
        debugger;
        const path = (this.files[viewName][identifier].save.service) + '$' + (this.files[viewName][identifier].save.function) + '$post';
        let form = new FormData();
        if (base_64) { // viene de la camara...
            form = file;
        }
        else {
            const archivo = file[0];
            form.append('file', archivo, archivo.name);
        }
        if (!isNullOrUndefined(this.localStorage.getItem('faceAPIEvaluation'))) {
            if (!isUndefined(this.files[viewName][identifier].save.data['description'])) {
                this.files[viewName][identifier].save.data['description'] = this.localStorage.getItem('faceAPIEvaluation');
            }
        }
        else {
            delete this.files[viewName][identifier].save.data['description'];
        }
        this.files[viewName][identifier].save.data.requirement['identifier'] = identifier;
        const obj = JSON.stringify(this.files[viewName][identifier].save.data);
        form.append('jsonObject', obj);
        return new Observable((resolve) => {
            this._path.getPathService(path).subscribe((resp) => {
                const url = resp.url;
                const req = new HttpRequest('POST', resp.url, form, {
                    reportProgress: true
                });
                return this._http.request(req).subscribe((event) => {
                    if (event.type === HttpEventType.UploadProgress && !isNullOrUndefined(event.loaded)) {
                        if (event.total) {
                            if (event.total > event.loaded) {
                                if (!isNaN(Math.round(event.loaded * 100 / event.total))) {
                                    this.files[viewName][identifier].progress = Math.round(event.loaded * 100 / event.total);
                                    if (this.files[viewName][identifier].progress === 100) {
                                        this.files[viewName][identifier].progress = 99;
                                    }
                                    this.setChangesFilesArr(this.files);
                                }
                            }
                            else {
                                this.files[viewName][identifier].progress = 99;
                                this.setChangesFilesArr(this.files);
                            }
                        }
                    }
                    else {
                        if ((event.statusText === 'OK' || event.statusText === 'Created') && event.body) {
                            if (this.files[viewName][identifier].object.requirement.requirementType === 'FOLDER') {
                                this.files[viewName][identifier].progress = null;
                                this.files[viewName][identifier].status = 'COMPLETED';
                            }
                            else {
                                this.files[viewName][identifier].progress = null;
                                this.files[viewName][identifier].status = 'COMPLETED';
                            }
                            this.setResponseUpload(event);
                            this.setChangeRequirementById(identifier);
                            resolve.next(event);
                            resolve.complete();
                        }
                    }
                    // console.log(event);
                }, (err) => {
                    // console.log(err);
                    /*
                    swal.fire({
                        title: this._i18n.transform('@i18n-popup-confirm-title-answer'),
                        html: '<b>' + this._i18n.transform('@i18n-popup-text-file-upload-error') + '</b>'
                    });*/
                    this._error.show(err);
                    if (err.error instanceof Error) {
                        // A client-side or network error occurred. Handle it accordingly.
                        // this._uploadFailed(queueObj, err);
                        this.files[viewName][identifier].progress = null;
                        // this.changeDataFile.next(this.files);
                        this.setChangeRequirementById(identifier);
                        resolve.next(event);
                        resolve.complete();
                    }
                    else {
                        this.files[viewName][identifier].progress = null;
                        // this.changeDataFile.next(this.files);
                        this.setResponseUpload(event);
                        this.setChangeRequirementById(identifier);
                        resolve.next(event);
                        resolve.complete();
                    }
                });
            });
        });
    }
    postFileCompress(file, identifier, viewName, base_64) {
        const path = (this.files[viewName][identifier].save.service) + '$' + (this.files[viewName][identifier].save.function) + '$post';
        let form = new FormData();
        if (base_64) { // viene de la camara...
            form = file;
        }
        else {
            const archivo = file;
            form.append('file', archivo, archivo.name);
        }
        if (!isNullOrUndefined(this.localStorage.getItem('faceAPIEvaluation'))) {
            if (!isUndefined(this.files[viewName][identifier].save.data['description'])) {
                this.files[viewName][identifier].save.data['description'] = this.localStorage.getItem('faceAPIEvaluation');
            }
        }
        else {
            delete this.files[viewName][identifier].save.data['description'];
        }
        const obj = JSON.stringify(this.files[viewName][identifier].save.data);
        form.append('jsonObject', obj);
        return new Observable((resolve) => {
            this._path.getPathService(path).subscribe((resp) => {
                const url = resp.url;
                const req = new HttpRequest('POST', resp.url, form, {
                    reportProgress: true
                });
                return this._http.request(req).subscribe((event) => {
                    if (event.type === HttpEventType.UploadProgress && !isNullOrUndefined(event.loaded)) {
                        if (event.total) {
                            if (event.total > event.loaded) {
                                if (!isNaN(Math.round(event.loaded * 100 / event.total))) {
                                    this.files[viewName][identifier].progress = Math.round(event.loaded * 100 / event.total);
                                    if (this.files[viewName][identifier].progress === 100) {
                                        this.files[viewName][identifier].progress = 99;
                                    }
                                    this.setChangesFilesArr(this.files);
                                }
                            }
                            else {
                                this.files[viewName][identifier].progress = 99;
                                this.setChangesFilesArr(this.files);
                            }
                        }
                    }
                    else {
                        if ((event.statusText === 'OK' || event.statusText === 'Created') && event.body) {
                            if (this.files[viewName][identifier].object.requirement.requirementType === 'FOLDER') {
                                this.files[viewName][identifier].progress = null;
                                this.files[viewName][identifier].status = 'COMPLETED';
                            }
                            else {
                                this.files[viewName][identifier].progress = null;
                                this.files[viewName][identifier].status = 'COMPLETED';
                            }
                            this.setResponseUpload(event);
                            this.setChangeRequirementById(identifier);
                            resolve.next(event);
                            resolve.complete();
                        }
                    }
                    // console.log(event);
                }, (err) => {
                    // console.log(err);
                    /*
                    swal.fire({
                        title: this._i18n.transform('@i18n-popup-confirm-title-answer'),
                        html: '<b>' + this._i18n.transform('@i18n-popup-text-file-upload-error') + '</b>'
                    });*/
                    this._error.show(err);
                    if (err.error instanceof Error) {
                        // A client-side or network error occurred. Handle it accordingly.
                        // this._uploadFailed(queueObj, err);
                        this.files[viewName][identifier].progress = null;
                        // this.changeDataFile.next(this.files);
                        this.setChangeRequirementById(identifier);
                        resolve.next(event);
                        resolve.complete();
                    }
                    else {
                        this.files[viewName][identifier].progress = null;
                        // this.changeDataFile.next(this.files);
                        this.setResponseUpload(event);
                        this.setChangeRequirementById(identifier);
                        resolve.next(event);
                        resolve.complete();
                    }
                });
            });
        });
    }
    showArchive(archive) {
        this.visor = false;
        if (archive.identifier !== null) {
            this.visor_params.archive = archive;
            this.setUpdateVisor();
            this.visor = true;
        }
    }
    wait() {
        swal.fire({
            title: '',
            showCancelButton: false,
            showCloseButton: false,
            showConfirmButton: false,
            html: '<b>' + this._i18n.transform('@i18n-text-please-wait') + '...<b><br><i class=\'fa fa-spin fa-spinner\'></i>',
        });
    }
    getFile() {
    }
    putFile() {
    }
    deleteFile() {
    }
    updateData(identifier, status) {
        this.files[identifier].status = status;
    }
}
/** @nocollapse */ UploadService.ɵfac = function UploadService_Factory(t) { return new (t || UploadService)(ɵɵinject(ErrorService), ɵɵinject(FileService), ɵɵinject(I18nPipe), ɵɵinject(PathService), ɵɵinject(HttpClient), ɵɵinject(LocalService)); };
/** @nocollapse */ UploadService.ɵprov = ɵɵdefineInjectable({ token: UploadService, factory: UploadService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(UploadService, [{
        type: Injectable
    }], function () { return [{ type: ErrorService }, { type: FileService }, { type: I18nPipe }, { type: PathService }, { type: HttpClient }, { type: LocalService }]; }, null); })();

function VisorComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 20);
    ɵɵpipe(1, "date");
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext(2);
    ɵɵproperty("innerHTML", ctx_r1.visor_params.archive.dateCreated.orderDate ? ɵɵpipeBind2(1, 1, ctx_r1.visor_params.archive.dateCreated.orderDate, "EEEE, Md MMM, y, h:mm:ss a zzzz") : "", ɵɵsanitizeHtml);
} }
function VisorComponent_div_0_ng_container_8_a_1_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 25);
} }
function VisorComponent_div_0_ng_container_8_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", 22);
    ɵɵlistener("click", function VisorComponent_div_0_ng_container_8_a_1_Template_a_click_0_listener() { ɵɵrestoreView(_r11); const ctx_r10 = ɵɵnextContext(3); return ctx_r10.download(ctx_r10.blob.name); });
    ɵɵtemplate(1, VisorComponent_div_0_ng_container_8_a_1_i_1_Template, 1, 0, "i", 23);
    ɵɵelementStart(2, "span", 24);
    ɵɵtext(3, "\u00A0\u00A0Descargar");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵɵnextContext(3);
    ɵɵclassProp("disabled", ctx_r8.progress_download);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r8.progress_download);
} }
function VisorComponent_div_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, VisorComponent_div_0_ng_container_8_a_1_Template, 4, 3, "a", 21);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.blob);
} }
function VisorComponent_div_0_ng_container_9_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 27);
} }
function VisorComponent_div_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, VisorComponent_div_0_ng_container_9_i_1_Template, 1, 0, "i", 26);
    ɵɵelementStart(2, "span", 24);
    ɵɵtext(3, "\u00A0\u00A0Descargando...");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.progress_download);
} }
function VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 28);
    ɵɵelement(2, "img", 29);
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r15 = ɵɵnextContext(4);
    ɵɵadvance(2);
    ɵɵproperty("src", ctx_r15.safe_file, ɵɵsanitizeUrl);
} }
function VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_2_ng_container_1_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "i", 37);
    ɵɵtext(2, " \u00A0Descargar ");
    ɵɵelementContainerEnd();
} }
function VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_2_ng_container_1_ng_container_10_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 27);
} }
function VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_2_ng_container_1_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_2_ng_container_1_ng_container_10_i_1_Template, 1, 0, "i", 26);
    ɵɵtext(2, "\u00A0\u00A0Descargando... ");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r19 = ɵɵnextContext(6);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r19.progress_download);
} }
function VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r22 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "object", 30);
    ɵɵelementStart(2, "div", 31);
    ɵɵelementStart(3, "div", 32);
    ɵɵelementStart(4, "div", 33);
    ɵɵelementStart(5, "div", 34);
    ɵɵtext(6, " No hay una vista previa disponible. ");
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 35);
    ɵɵelementStart(8, "div", 36);
    ɵɵlistener("click", function VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_2_ng_container_1_Template_div_click_8_listener() { ɵɵrestoreView(_r22); const ctx_r21 = ɵɵnextContext(5); return ctx_r21.download(ctx_r21.blob.name); });
    ɵɵtemplate(9, VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_2_ng_container_1_ng_container_9_Template, 3, 0, "ng-container", 9);
    ɵɵtemplate(10, VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_2_ng_container_1_ng_container_10_Template, 3, 1, "ng-container", 9);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r17 = ɵɵnextContext(5);
    ɵɵadvance(1);
    ɵɵproperty("data", ctx_r17.safe_file, ɵɵsanitizeResourceUrl);
    ɵɵadvance(8);
    ɵɵproperty("ngIf", !ctx_r17.progress_download);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r17.progress_download);
} }
function VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_2_ng_container_1_Template, 11, 3, "ng-container", 9);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r16 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r16.safe_file);
} }
function VisorComponent_div_0_ng_container_17_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_1_Template, 3, 1, "ng-container", 9);
    ɵɵtemplate(2, VisorComponent_div_0_ng_container_17_ng_container_1_ng_container_2_Template, 2, 1, "ng-container", 9);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r13.blob.type === "image/png" || ctx_r13.blob.type === "image/jpg" || ctx_r13.blob.type === "image/jpeg");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r13.blob.type !== "image/png" && ctx_r13.blob.type !== "image/jpg" && ctx_r13.blob.type !== "image/jpeg");
} }
function VisorComponent_div_0_ng_container_17_ng_container_2_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "i", 37);
    ɵɵtext(2, " \u00A0Descargar ");
    ɵɵelementContainerEnd();
} }
function VisorComponent_div_0_ng_container_17_ng_container_2_ng_container_7_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 27);
} }
function VisorComponent_div_0_ng_container_17_ng_container_2_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, VisorComponent_div_0_ng_container_17_ng_container_2_ng_container_7_i_1_Template, 1, 0, "i", 26);
    ɵɵtext(2, "\u00A0\u00A0Descargando... ");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r24 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r24.progress_download);
} }
function VisorComponent_div_0_ng_container_17_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "div", 33);
    ɵɵelementStart(2, "div", 34);
    ɵɵtext(3, " No hay una vista previa disponible. ");
    ɵɵelementEnd();
    ɵɵelementStart(4, "div", 35);
    ɵɵelementStart(5, "div", 36);
    ɵɵlistener("click", function VisorComponent_div_0_ng_container_17_ng_container_2_Template_div_click_5_listener() { ɵɵrestoreView(_r27); const ctx_r26 = ɵɵnextContext(3); return ctx_r26.download(ctx_r26.blob.name); });
    ɵɵtemplate(6, VisorComponent_div_0_ng_container_17_ng_container_2_ng_container_6_Template, 3, 0, "ng-container", 9);
    ɵɵtemplate(7, VisorComponent_div_0_ng_container_17_ng_container_2_ng_container_7_Template, 3, 1, "ng-container", 9);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r14 = ɵɵnextContext(3);
    ɵɵadvance(6);
    ɵɵproperty("ngIf", !ctx_r14.progress_download);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r14.progress_download);
} }
function VisorComponent_div_0_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, VisorComponent_div_0_ng_container_17_ng_container_1_Template, 3, 2, "ng-container", 9);
    ɵɵtemplate(2, VisorComponent_div_0_ng_container_17_ng_container_2_Template, 8, 2, "ng-container", 9);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.enablePreview);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r4.enablePreview);
} }
function VisorComponent_div_0_i_18_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 38);
} }
function VisorComponent_div_0_ng_container_19_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "i", 39);
    ɵɵelement(2, "div", 40);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", "Ha ocurrido un error...<br><b> \u00A1Archivo no encontrado!</b>", ɵɵsanitizeHtml);
} }
function VisorComponent_div_0_ng_container_19_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "i", 39);
    ɵɵelement(2, "div", 40);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵɵadvance(2);
    ɵɵproperty("innerHTML", "Something is wrong...<br><b> Error Interno</b>", ɵɵsanitizeHtml);
} }
function VisorComponent_div_0_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, VisorComponent_div_0_ng_container_19_ng_container_1_Template, 3, 1, "ng-container", 9);
    ɵɵtemplate(2, VisorComponent_div_0_ng_container_19_ng_container_2_Template, 3, 1, "ng-container", 9);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r6.error.status === 404);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r6.error.status === 500);
} }
function VisorComponent_div_0_div_20_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r32 = ɵɵgetCurrentView();
    ɵɵnamespaceSVG();
    ɵɵnamespaceHTML();
    ɵɵelementStart(0, "div", 46);
    ɵɵelementStart(1, "a", 47);
    ɵɵlistener("click", function VisorComponent_div_0_div_20_div_4_Template_a_click_1_listener() { ɵɵrestoreView(_r32); const ctx_r31 = ɵɵnextContext(3); return ctx_r31.action("right", ctx_r31.next); });
    ɵɵnamespaceSVG();
    ɵɵelementStart(2, "svg", 48);
    ɵɵelement(3, "path", 49);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function VisorComponent_div_0_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r34 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 41);
    ɵɵelementStart(1, "a", 42);
    ɵɵlistener("click", function VisorComponent_div_0_div_20_Template_a_click_1_listener() { ɵɵrestoreView(_r34); const ctx_r33 = ɵɵnextContext(2); return ctx_r33.action("left", ctx_r33.back); });
    ɵɵnamespaceSVG();
    ɵɵelementStart(2, "svg", 43);
    ɵɵelement(3, "path", 44);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(4, VisorComponent_div_0_div_20_div_4_Template, 4, 0, "div", 45);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(2);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r7.next);
} }
function VisorComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r36 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 1);
    ɵɵelementStart(1, "div", 2);
    ɵɵelementStart(2, "div", 3);
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "div", 5);
    ɵɵelement(5, "div", 6);
    ɵɵtemplate(6, VisorComponent_div_0_div_6_Template, 2, 4, "div", 7);
    ɵɵelementEnd();
    ɵɵelementStart(7, "div", 8);
    ɵɵtemplate(8, VisorComponent_div_0_ng_container_8_Template, 2, 1, "ng-container", 9);
    ɵɵtemplate(9, VisorComponent_div_0_ng_container_9_Template, 4, 1, "ng-container", 9);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(10, "div", 10);
    ɵɵelementStart(11, "a", 11);
    ɵɵlistener("click", function VisorComponent_div_0_Template_a_click_11_listener() { ɵɵrestoreView(_r36); const ctx_r35 = ɵɵnextContext(); return ctx_r35.window_close(); });
    ɵɵnamespaceSVG();
    ɵɵelementStart(12, "svg", 12);
    ɵɵelement(13, "path", 13);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵnamespaceHTML();
    ɵɵelementStart(14, "div", 14);
    ɵɵelementStart(15, "div", 15);
    ɵɵelementStart(16, "div", 16);
    ɵɵtemplate(17, VisorComponent_div_0_ng_container_17_Template, 3, 2, "ng-container", 9);
    ɵɵtemplate(18, VisorComponent_div_0_i_18_Template, 1, 0, "i", 17);
    ɵɵtemplate(19, VisorComponent_div_0_ng_container_19_Template, 3, 2, "ng-container", 9);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(20, VisorComponent_div_0_div_20_Template, 5, 1, "div", 18);
    ɵɵelementEnd();
    ɵɵelement(21, "div", 19);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵclassProp("zoomOut", ctx_r0.activate_close)("zoomIn", !ctx_r0.activate_close);
    ɵɵadvance(5);
    ɵɵproperty("innerHTML", ctx_r0.blob == null ? null : ctx_r0.blob.name, ɵɵsanitizeHtml);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r0.error && ctx_r0.blob);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", !ctx_r0.progress_download);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.progress_download);
    ɵɵadvance(8);
    ɵɵproperty("ngIf", ctx_r0.blob && !ctx_r0.error);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r0.blob && !ctx_r0.error);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.error !== null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.back);
} }
class VisorComponent {
    constructor(upload, _i18n, sanitizer, file) {
        this.upload = upload;
        this._i18n = _i18n;
        this.sanitizer = sanitizer;
        this.file = file;
        this.filename = '';
        this.filedate = '';
        this.filedownloadlink = '';
        this.next = null;
        this.back = null;
        this.close = new EventEmitter();
        this.eventaction = new EventEmitter();
        this.blob = null;
        this._file = null;
        this.html = null;
        this.error = null;
        this.progress_download = false;
        this.activate_close = true;
        this.isNotClosed = false;
        this.direct_download = true;
        this.safe_file = null;
        this.url = null;
        this.enablePreview = true;
    }
    ngOnInit() {
        this.update();
        this.upload.getUpdateVisor().subscribe((data) => {
            this.update();
        });
    }
    update() {
        this.blob = null;
        this.error = null;
        if (!isNullOrUndefined(this.visor_params.action)) {
            if (this.visor_params.action === 'download') {
                this.download(this.visor_params.archive.name);
            }
            else {
                //this.download(this.visor_params.archive.name);
                this.process();
            }
        }
        else {
            //this.download(this.visor_params.archive.name);
            this.process();
        }
    }
    process() {
        this.direct_download = false;
        this.activate_close = false;
        this.isNotClosed = false;
        this.file.getFile(this.visor_params.archive.identifier, 'inline', this.visor_params.archive.name, this.visor_params.endpoint).subscribe((blob) => {
            const file = new File([new Blob()], blob.name, { type: blob.type });
            this.blob = blob;
            if (blob.content === 'inline' && blob.type !== 'application/octet-stream') {
                if (blob.type.indexOf('pdf') !== -1) {
                    this.getSafeUrl(true);
                }
                else if (blob.type.indexOf('image') !== -1) {
                    this.getSafeUrl();
                }
                else {
                    this.enablePreview = false;
                }
            }
            else {
                this.enablePreview = false;
                // if (blob.type === 'application/octet-stream') {
                //   this.window_close();
                // }
                // se envia el archivo a descarga directa.
                // if (window.navigator.msSaveOrOpenBlob) {
                //   // window.navigator.msSaveOrOpenBlob(blob.blob, blob.name);
                // } else {
                //   const a = document.createElement('a');
                //   document.body.appendChild(a);
                //   const url = window.URL.createObjectURL(blob.blob);
                //   a.href = url;
                //   a.download = blob.name;
                //   a.click();
                //   setTimeout(() => {
                //     window.URL.revokeObjectURL(url);
                //     document.body.removeChild(a);
                //   }, 0);
                // }
            }
        }, (error) => {
            this.error = error;
            this.blob = null;
        });
    }
    download(name) {
        this.wait();
        this.progress_download = true;
        this.file.getFile(this.visor_params.archive.identifier, 'attachment', name, this.visor_params.endpoint).subscribe((blob) => {
            // se envia el archivo a descarga directa.
            if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob.blob, blob.name);
            }
            else {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const url = window.URL.createObjectURL(blob.blob);
                a.href = url;
                a.download = blob.name;
                a.click();
                setTimeout(() => {
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                }, 0);
            }
            this.action('finish_download_success');
            swal.close();
            this.progress_download = false;
        }, (error) => {
            this.action('finish_download_error');
            swal.close();
            this.progress_download = false;
        });
    }
    wait() {
        swal.fire({
            title: '',
            showCancelButton: false,
            showCloseButton: false,
            showConfirmButton: false,
            html: '<b>' + this._i18n.transform('@i18n-text-please-wait') + '...<b><br><i class="fa fa-spin fa-spinner"></i>',
        });
    }
    getSafeUrl(pdf) {
        let url = '';
        this.safe_file = null;
        if (!isNullOrUndefined(pdf)) {
            url = URL.createObjectURL(this.blob.blob);
            this.url = url;
            this.safe_file = this.sanitizer.bypassSecurityTrustResourceUrl(url + '#toolbar=0&navpanes=0');
            setTimeout(() => {
                //URL.revokeObjectURL(url);
            }, 30);
            // return this.sanitizer.bypassSecurityTrustResourceUrl(url+ '#toolbar=0&navpanes=0');
        }
        else {
            url = URL.createObjectURL(this.blob.blob);
            this.safe_file = this.sanitizer.bypassSecurityTrustResourceUrl(url);
            setTimeout(() => {
                //URL.revokeObjectURL(url);
            }, 30);
            // return this.sanitizer.bypassSecurityTrustResourceUrl(url);
        }
    }
    window_close() {
        this.safe_file = null;
        this.isNotClosed = true;
        this.activate_close = true;
        setTimeout(() => {
            this.close.emit(true);
        }, 300);
    }
    action(type, archive_identifier) {
        switch (type) {
            case 'left':
                this.eventaction.emit({ action: 'move', direction: type, object: archive_identifier });
                break;
            case 'right':
                this.eventaction.emit({ action: 'move', direction: type, object: archive_identifier });
                break;
            case 'finish_download_success':
                this.eventaction.emit({ action: 'download', status: 'success', deleteAfterShow: this.visor_params['deleteAfterShow'] });
                break;
            case 'finish_download_error':
                this.eventaction.emit({ action: 'download', status: 'error', deleteAfterShow: this.visor_params['deleteAfterShow'] });
                break;
        }
    }
}
/** @nocollapse */ VisorComponent.ɵfac = function VisorComponent_Factory(t) { return new (t || VisorComponent)(ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(FileService)); };
/** @nocollapse */ VisorComponent.ɵcmp = ɵɵdefineComponent({ type: VisorComponent, selectors: [["akeela-visor"]], inputs: { filename: "filename", filedate: "filedate", filedownloadlink: "filedownloadlink", next: "next", back: "back", visor_params: ["visorparams", "visor_params"] }, outputs: { close: "close", eventaction: "eventaction" }, decls: 1, vars: 1, consts: [["class", "animated ModalLayer", "tabindex", "-1", 3, "zoomOut", "zoomIn", 4, "ngIf"], ["tabindex", "-1", 1, "animated", "ModalLayer"], [1, "AttachmentsCarousel--withThumbnails", "AttachmentsCarousel"], [1, "AttachmentMetadataBar"], [1, "AttachmentMetadataBar-left"], [1, "AttachmentMetadataBar-attachmentDetails"], [1, "AttachmentMetadataBar-attachmentName", 3, "innerHTML"], ["class", "AttachmentMetadataBar-attachmentCreatedTime", 3, "innerHTML", 4, "ngIf"], [1, "AttachmentMetadataBar-attachmentButtons"], [4, "ngIf"], [1, "AttachmentMetadataBar-right"], [1, "CloseButton", "AttachmentMetadataBar-closeButton", "close", 3, "click"], ["focusable", "false", "viewBox", "0 0 32 32", 1, "Icon", "XIcon", "CloseButton-xIcon"], ["d", "M18.1,16L27,7.1c0.6-0.6,0.6-1.5,0-2.1s-1.5-0.6-2.1,0L16,13.9l-8.9-9C6.5,4.3,5.6,4.3,5,4.9S4.4,6.4,5,7l8.9,8.9L5,24.8c-0.6,0.6-0.6,1.5,0,2.1c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4l8.9-8.9l8.9,8.9c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4c0.6-0.6,0.6-1.5,0-2.1L18.1,16z"], [1, "AttachmentsCarousel-carouselContainer"], [1, "Carousel--withOnImageButtons", "Carousel", "AttachmentsCarousel-carousel"], [1, "AttachmentsCarouselSlide", "Carousel-child", "AttachmentsCarousel-previewImage"], ["class", "fas fa-spinner fa-spin fa-5x", "style", "columns: #d4d4d4;", 4, "ngIf"], ["class", "Carousel-leftButtonContainer", 4, "ngIf"], [1, "AttachmentsCarousel-indexThumbnails"], [1, "AttachmentMetadataBar-attachmentCreatedTime", 3, "innerHTML"], ["class", "AttachmentMetadataBar-downloadLink active-cursor", 3, "disabled", "click", 4, "ngIf"], [1, "AttachmentMetadataBar-downloadLink", "active-cursor", 3, "click"], ["class", "fa fa-download", 4, "ngIf"], [1, "d-none", "d-md-block"], [1, "fa", "fa-download"], ["class", "fa fa-spinner fa-spin", 4, "ngIf"], [1, "fa", "fa-spinner", "fa-spin"], [1, "AttachmentImageWithRotation", 2, "padding", "0px"], [1, "AttachmentImageWithRotation-image", 3, "src"], ["type", "application/pdf", "width", "100%", "height", "800px", 3, "data"], [1, "div-container"], [1, "div-child"], ["tabindex", "-1", 1, "container-noPreview"], ["tabindex", "-1", 1, "noPreview-title", "ndfHFb-c4YZDc-AHmuwe-wcotoc-zTETae"], ["tabindex", "0", "role", "button", "data-tooltip-unhoverable", "true", "data-tooltip-delay", "500", "data-tooltip-class", "ndfHFb-c4YZDc-tk3N6e-suEOdc", "data-tooltip-align", "b,c", "data-tooltip-offset", "-6", "aria-label", "Descargar", "data-tooltip", "Descargar", 1, "ndfHFb-c4YZDc-LgbsSe", "ndfHFb-c4YZDc-bN97Pc-nupQLb-LgbsSe"], ["aria-hidden", "true", 1, "noPreview-download-button", 3, "click"], [1, "fas", "fa-download"], [1, "fas", "fa-spinner", "fa-spin", "fa-5x", 2, "columns", "#d4d4d4"], ["aria-hidden", "true", 1, "fa", "fa-frown-o", 2, "color", "white", "font-size", "5rem"], [2, "color", "white", "text-align", "center", 3, "innerHTML"], [1, "Carousel-leftButtonContainer"], ["tabindex", "0", "role", "button", "aria-disabled", "false", 1, "CircularButton", "CircularButton--enabled", "CircularButton--medium", "CircularButton--circular", "Carousel-leftButton", 3, "click"], ["focusable", "false", "viewBox", "0 0 32 32", 1, "Icon", "LeftIcon"], ["d", "M8.8,16c0-0.3,0.1-0.7,0.3-0.9l9-11c0.5-0.6,1.5-0.7,2.1-0.2s0.7,1.5,0.2,2.1l-8.2,10l8.2,10c0.5,0.6,0.4,1.6-0.2,2.1s-1.6,0.4-2.1-0.2l-9-11C8.9,16.7,8.8,16.3,8.8,16z"], ["class", "Carousel-rightButtonContainer", 4, "ngIf"], [1, "Carousel-rightButtonContainer"], ["tabindex", "0", "role", "button", "aria-disabled", "false", 1, "CircularButton", "CircularButton--enabled", "CircularButton--medium", "CircularButton--circular", "Carousel-rightButton", 3, "click"], ["focusable", "false", "viewBox", "0 0 32 32", 1, "Icon", "RightIcon"], ["d", "M23.2,16c0,0.3-0.1,0.7-0.3,0.9l-9,11c-0.5,0.6-1.5,0.7-2.1,0.2s-0.7-1.5-0.2-2.1l8.2-10L11.6,6c-0.5-0.6-0.4-1.6,0.2-2.1s1.6-0.4,2.1,0.2l9,11C23.1,15.3,23.2,15.7,23.2,16z"]], template: function VisorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, VisorComponent_div_0_Template, 22, 12, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", !ctx.direct_download);
    } }, directives: [NgIf], pipes: [DatePipe], styles: [".ModalLayer[_ngcontent-%COMP%]{align-items:center;bottom:0;display:flex;flex-direction:column;left:0;position:fixed;right:0;top:0;z-index:10000}.Carousel-leftButtonContainer[_ngcontent-%COMP%]{left:15px}.Carousel-rightButtonContainer[_ngcontent-%COMP%]{right:15px}.Carousel-leftButtonContainer[_ngcontent-%COMP%], .Carousel-rightButtonContainer[_ngcontent-%COMP%]{align-items:center;cursor:pointer;display:flex;flex-direction:column;height:100%;justify-content:center;position:absolute;top:0;z-index:10331}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}.CircularButton.CircularButton--medium[_ngcontent-%COMP%]{height:30px;width:30px}.Carousel-leftButton[_ngcontent-%COMP%], .Carousel-rightButton[_ngcontent-%COMP%]{box-shadow:0 5px 20px 0 rgba(21,27,38,.08)}.CircularButton--circular[_ngcontent-%COMP%]{background:#fff;border:1px solid #b7bfc6;border-radius:50%;box-sizing:border-box;color:#848f99;fill:#848f99;flex:0 0 auto;font-size:13px;height:30px;line-height:1;transition:box-shadow .2s,color .2s,background .2s,fill .2s,border-color .2s;width:30px}.CircularButton[_ngcontent-%COMP%]{align-items:center;display:inline-flex;justify-content:center}a[_ngcontent-%COMP%]{color:#14aaf5;cursor:pointer;text-decoration:none}.AttachmentMetadataBar[_ngcontent-%COMP%]{align-items:center;background-color:#000;border-bottom:1px solid rgba(100,111,121,.4);color:#fff;display:flex;flex:0 0 auto;font-size:16px;font-weight:400;line-height:20px}.AttachmentsCarousel[_ngcontent-%COMP%]{background-color:#0c0c0c;display:flex;flex:1 1 auto;flex-direction:column;min-height:1px;min-width:1px;width:100%}.CloseButton[_ngcontent-%COMP%]{align-items:center;display:inline-flex;fill:#848f99}.AttachmentImageWithRotation[_ngcontent-%COMP%]{align-items:center;box-sizing:border-box;display:flex;flex-direction:column;height:100%;justify-content:center;position:relative;width:100%}.AttachmentImageWithRotation-image[_ngcontent-%COMP%]{background-color:#fff;flex:0 1 auto;max-height:100%;max-width:100%;min-height:1px;width:auto}.AttachmentsCarousel-previewImage.AttachmentsCarouselSlide[_ngcontent-%COMP%]{border-left-width:0;border-right-width:0}.AttachmentsCarouselSlide[_ngcontent-%COMP%]{background:#000;border:20px solid transparent}.Carousel-child[_ngcontent-%COMP%]{height:100%;left:0;position:absolute;top:0;width:100%}.AttachmentsCarouselPlaceholder-nonImagePlaceholder[_ngcontent-%COMP%]{align-items:center;color:#fff;display:flex;flex-direction:column}.AttachmentMetadataBar-left[_ngcontent-%COMP%]{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between;margin-right:20px;min-width:1px}.AttachmentMetadataBar-attachmentDetails[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;flex-direction:column;margin-left:20px;margin-right:20px;min-width:1px}.AttachmentMetadataBar-attachmentName[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.AttachmentMetadataBar-attachmentCreatedTime[_ngcontent-%COMP%]{color:#848f99}.AttachmentMetadataBar-attachmentButtons[_ngcontent-%COMP%]{display:flex;flex-direction:row}.AttachmentMetadataBar-closeButton[_ngcontent-%COMP%]   .Icon[_ngcontent-%COMP%]{height:24px;width:24px}.AttachmentMetadataBar-closeButton[_ngcontent-%COMP%]{fill:#fff;opacity:.5}.AttachmentMetadataBar-annotateIcon[_ngcontent-%COMP%], .AttachmentMetadataBar-downloadIcon[_ngcontent-%COMP%]{flex:0 0 auto;margin-right:10px}.Icon[_ngcontent-%COMP%]{height:16px;width:16px}foreignObject[_ngcontent-%COMP%], image[_ngcontent-%COMP%], marker[_ngcontent-%COMP%], pattern[_ngcontent-%COMP%], svg[_ngcontent-%COMP%]:not(:root), symbol[_ngcontent-%COMP%], user[_ngcontent-%COMP%]   agent[_ngcontent-%COMP%]   stylesheet[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]:not(:root){overflow:hidden}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{background:transparent;border-color:#fff;color:#fff;fill:#fff}.AttachmentMetadataBar-right[_ngcontent-%COMP%]{align-items:center;border-left:1px solid rgba(100,111,121,.4);display:flex;flex:0 0 auto;height:60px;justify-content:center;width:60px}.AttachmentsCarousel-carouselContainer[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;flex-direction:row;min-height:1px}.AttachmentsCarousel-carousel[_ngcontent-%COMP%]{flex:1 1 auto;min-width:1px}.Carousel[_ngcontent-%COMP%]{overflow:hidden;position:relative;z-index:100}.AttachmentsCarousel-previewImage[_ngcontent-%COMP%]{border-left-width:0;border-right-width:0}.AttachmentsCarouselSlide[_ngcontent-%COMP%]{align-items:center;border:0 solid transparent;box-sizing:border-box;display:flex;flex-direction:column;justify-content:center}.AttachmentMetadataBar-downloadLink[_ngcontent-%COMP%], .AttachmentMetadataBar-openOriginalLink[_ngcontent-%COMP%], .AttachmentMetadataBar-proofingToggle[_ngcontent-%COMP%]{align-items:center;border-radius:4px;color:#fff;display:flex;fill:#fff;flex:0 0 auto;height:40px;margin-right:15px;padding:0 10px;white-space:nowrap}.container-noPreview[_ngcontent-%COMP%]{background-color:#4c494c;border-radius:12px;box-shadow:0 10px 12px 5px rgba(0,0,0,.2);color:#fff;margin-bottom:40px;padding:20px;text-align:center}.noPreview-title[_ngcontent-%COMP%]{-webkit-user-select:text;display:inline-block;font-size:19px;line-height:27px}.noPreview-download[_ngcontent-%COMP%]{margin-left:35px;margin-right:10px}.noPreview-download-button[_ngcontent-%COMP%]{background-color:#4d90fe;border:1px solid #4d90fe;border-radius:2px;box-shadow:inset 0 1px 0 hsla(0,0%,39.6%,.1);color:#fff;display:inline-block;font-size:11px;font-weight:700;height:28px;line-height:28px;margin-top:20px;min-width:54px;padding:0 20px 0 7px;text-align:center;text-shadow:0 1px 0 rgba(0,0,0,.8);vertical-align:middle;white-space:nowrap}.div-container[_ngcontent-%COMP%]{height:100%!important;min-height:100%!important}.div-child[_ngcontent-%COMP%]{height:auto;margin:0 auto;padding:10px;position:relative;width:auto}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(VisorComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-visor',
                templateUrl: './visor.component.html',
                styleUrls: ['./visor.component.css']
            }]
    }], function () { return [{ type: UploadService }, { type: I18nPipe }, { type: DomSanitizer }, { type: FileService }]; }, { filename: [{
            type: Input
        }], filedate: [{
            type: Input
        }], filedownloadlink: [{
            type: Input
        }], next: [{
            type: Input
        }], back: [{
            type: Input
        }], visor_params: [{
            type: Input,
            args: ['visorparams']
        }], close: [{
            type: Output
        }], eventaction: [{
            type: Output
        }] }); })();

function VisorGoogleComponent_div_0_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "div", 18);
    ɵɵpipe(1, "date");
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext(2);
    ɵɵproperty("innerHTML", ctx_r1.archive.dateCreated.orderDate ? ɵɵpipeBind2(1, 1, ctx_r1.archive.dateCreated.orderDate, "EEEE, Md MMM, y, h:mm:ss a zzzz") : "", ɵɵsanitizeHtml);
} }
function VisorGoogleComponent_div_0_ng_container_11_a_1_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 22);
} }
function VisorGoogleComponent_div_0_ng_container_11_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "a", 20);
    ɵɵlistener("click", function VisorGoogleComponent_div_0_ng_container_11_a_1_Template_a_click_0_listener() { ɵɵrestoreView(_r10); const ctx_r9 = ɵɵnextContext(3); return ctx_r9.download(ctx_r9.archive.name); });
    ɵɵtemplate(1, VisorGoogleComponent_div_0_ng_container_11_a_1_i_1_Template, 1, 0, "i", 21);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵɵnextContext(3);
    ɵɵclassProp("disabled", ctx_r7.progress_download);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r7.progress_download);
} }
function VisorGoogleComponent_div_0_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, VisorGoogleComponent_div_0_ng_container_11_a_1_Template, 2, 3, "a", 19);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r2.archive);
} }
function VisorGoogleComponent_div_0_ng_container_12_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "i", 25);
} }
function VisorGoogleComponent_div_0_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, VisorGoogleComponent_div_0_ng_container_12_i_1_Template, 1, 0, "i", 23);
    ɵɵelementStart(2, "span", 24);
    ɵɵtext(3, "\u00A0\u00A0Descargando...");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.progress_download);
} }
function VisorGoogleComponent_div_0_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 26);
    ɵɵelement(1, "div", 27);
    ɵɵelement(2, "div", 27);
    ɵɵelement(3, "div", 27);
    ɵɵelementEnd();
} }
function VisorGoogleComponent_div_0_ng_container_17_ng_container_1_iframe_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "iframe", 29);
} if (rf & 2) {
    const ctx_r14 = ɵɵnextContext(4);
    ɵɵproperty("src", ctx_r14.url, ɵɵsanitizeResourceUrl);
} }
function VisorGoogleComponent_div_0_ng_container_17_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, VisorGoogleComponent_div_0_ng_container_17_ng_container_1_iframe_1_Template, 1, 1, "iframe", 28);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r12.url !== null);
} }
const _c0 = function (a0) { return [a0]; };
function VisorGoogleComponent_div_0_ng_container_17_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "ngx-image-viewer", 30);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("src", ɵɵpureFunction1(1, _c0, ctx_r13.url));
} }
function VisorGoogleComponent_div_0_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, VisorGoogleComponent_div_0_ng_container_17_ng_container_1_Template, 2, 1, "ng-container", 11);
    ɵɵtemplate(2, VisorGoogleComponent_div_0_ng_container_17_ng_container_2_Template, 2, 3, "ng-container", 11);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r5.isImage && ctx_r5.url);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.isImage && ctx_r5.url);
} }
function VisorGoogleComponent_div_0_div_18_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵɵgetCurrentView();
    ɵɵnamespaceSVG();
    ɵɵnamespaceHTML();
    ɵɵelementStart(0, "div", 36);
    ɵɵelementStart(1, "a", 37);
    ɵɵlistener("click", function VisorGoogleComponent_div_0_div_18_div_4_Template_a_click_1_listener() { ɵɵrestoreView(_r17); const ctx_r16 = ɵɵnextContext(3); return ctx_r16.action("right", ctx_r16.next); });
    ɵɵnamespaceSVG();
    ɵɵelementStart(2, "svg", 38);
    ɵɵelement(3, "path", 39);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function VisorGoogleComponent_div_0_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 31);
    ɵɵelementStart(1, "a", 32);
    ɵɵlistener("click", function VisorGoogleComponent_div_0_div_18_Template_a_click_1_listener() { ɵɵrestoreView(_r19); const ctx_r18 = ɵɵnextContext(2); return ctx_r18.action("left", ctx_r18.back); });
    ɵɵnamespaceSVG();
    ɵɵelementStart(2, "svg", 33);
    ɵɵelement(3, "path", 34);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(4, VisorGoogleComponent_div_0_div_18_div_4_Template, 4, 0, "div", 35);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵɵnextContext(2);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r6.next);
} }
function VisorGoogleComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 1);
    ɵɵelementStart(1, "div", 2);
    ɵɵelementStart(2, "div", 3);
    ɵɵelementStart(3, "div", 4);
    ɵɵelementStart(4, "div", 5);
    ɵɵelementStart(5, "div", 6);
    ɵɵelementStart(6, "span", 7);
    ɵɵlistener("click", function VisorGoogleComponent_div_0_Template_span_click_6_listener() { ɵɵrestoreView(_r21); const ctx_r20 = ɵɵnextContext(); return ctx_r20.window_close(); });
    ɵɵelement(7, "i", 8);
    ɵɵelementEnd();
    ɵɵtext(8);
    ɵɵelementEnd();
    ɵɵtemplate(9, VisorGoogleComponent_div_0_div_9_Template, 2, 4, "div", 9);
    ɵɵelementEnd();
    ɵɵelementStart(10, "div", 10);
    ɵɵtemplate(11, VisorGoogleComponent_div_0_ng_container_11_Template, 2, 1, "ng-container", 11);
    ɵɵtemplate(12, VisorGoogleComponent_div_0_ng_container_12_Template, 4, 1, "ng-container", 11);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(13, "div", 12);
    ɵɵelementStart(14, "div", 13);
    ɵɵelementStart(15, "div", 14);
    ɵɵtemplate(16, VisorGoogleComponent_div_0_div_16_Template, 4, 0, "div", 15);
    ɵɵtemplate(17, VisorGoogleComponent_div_0_ng_container_17_Template, 3, 2, "ng-container", 11);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(18, VisorGoogleComponent_div_0_div_18_Template, 5, 1, "div", 16);
    ɵɵelementEnd();
    ɵɵelement(19, "div", 17);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵclassProp("zoomOut", ctx_r0.activate_close)("zoomIn", !ctx_r0.activate_close);
    ɵɵadvance(8);
    ɵɵtextInterpolate1(" ", ctx_r0.archive == null ? null : ctx_r0.archive.name, "");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r0.error && ctx_r0.archive);
    ɵɵadvance(2);
    ɵɵproperty("ngIf", !ctx_r0.progress_download);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.progress_download);
    ɵɵadvance(4);
    ɵɵproperty("ngIf", ctx_r0.loading);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.archive && ctx_r0.isImage !== null);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.back);
} }
class VisorGoogleComponent {
    constructor(_path, upload, _i18n, sanitizer, file) {
        this._path = _path;
        this.upload = upload;
        this._i18n = _i18n;
        this.sanitizer = sanitizer;
        this.file = file;
        this.filename = '';
        this.filedate = '';
        this.filedownloadlink = '';
        this.next = null;
        this.back = null;
        this.close = new EventEmitter();
        this.eventaction = new EventEmitter();
        this.blob = null;
        this._file = null;
        this.html = null;
        this.error = null;
        this.progress_download = false;
        this.activate_close = true;
        this.isNotClosed = false;
        this.direct_download = true;
        this.safe_file = null;
        this.url = null;
        this.enablePreview = true;
        this.loading = false;
        this.archive = null;
        this.extensions_google_visor = ['.ppt', '.pptx', '.doc', '.docx', '.xls', '.xlsx', '.pdf'];
        this.extensions_images = ['.jpg', '.jpeg', '.png', '.gift', '.svg'];
        this.isImage = null;
        this.viewerUrl = 'https://docs.google.com/gview?url=%URL%&embedded=true';
        this.getExtension = (archive) => {
            return (archive.name.substring(archive.name.lastIndexOf('.'))).toLowerCase();
        };
        this.validateType = (ext, extensions_enabled) => {
            return extensions_enabled.includes(ext);
        };
        this.getUrl = (archive, sanitize) => __awaiter(this, void 0, void 0, function* () {
            const endpoint = yield this.getEndpointByKey('archive$downloadFile$get');
            if (!isNullOrUndefined(sanitize)) {
                if (sanitize) {
                    return this.sanitizer.bypassSecurityTrustResourceUrl(`${endpoint.url}?idArchive=${archive.identifier}&contentDisposition=inline`);
                }
                else {
                    return `${endpoint.url}?idArchive=${archive.identifier}&contentDisposition=inline`;
                }
            }
            else {
                return `${endpoint.url}?idArchive=${archive.identifier}&contentDisposition=inline`;
            }
        });
        this.getEndpointByKey = (endpoint) => __awaiter(this, void 0, void 0, function* () {
            return yield this._path.getPathService(endpoint).toPromise();
        });
        this.download = (name) => {
            this.wait();
            this.progress_download = true;
            this.file.getFile(this.visor_params.archive.identifier, 'attachment', name, this.visor_params.endpoint).subscribe((blob) => {
                // se envia el archivo a descarga directa.
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob.blob, blob.name);
                }
                else {
                    const a = document.createElement('a');
                    document.body.appendChild(a);
                    const url = window.URL.createObjectURL(blob.blob);
                    a.href = url;
                    a.download = blob.name;
                    a.click();
                    setTimeout(() => {
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a);
                    }, 0);
                }
                this.action('finish_download_success');
                swal.close();
                this.progress_download = false;
            }, (error) => {
                this.action('finish_download_error');
                swal.close();
                this.progress_download = false;
            });
        };
        this.wait = () => {
            swal.fire({
                title: '',
                showCancelButton: false,
                showCloseButton: false,
                showConfirmButton: false,
                html: '<b>' + this._i18n.transform('@i18n-text-please-wait') + '...<b><br><i class="fa fa-spin fa-spinner"></i>',
            });
        };
        this.window_close = () => {
            this.safe_file = null;
            this.isNotClosed = true;
            this.activate_close = true;
            setTimeout(() => {
                this.close.emit(true);
            }, 300);
        };
        this.response_visor = () => {
            this.loading = false;
        };
        this.action = (type, archive_identifier) => {
            switch (type) {
                case 'left':
                    this.eventaction.emit({ action: 'move', direction: type, object: archive_identifier });
                    break;
                case 'right':
                    this.eventaction.emit({ action: 'move', direction: type, object: archive_identifier });
                    break;
                case 'finish_download_success':
                    this.eventaction.emit({ action: 'download', status: 'success', deleteAfterShow: this.visor_params['deleteAfterShow'] });
                    break;
                case 'finish_download_error':
                    this.eventaction.emit({ action: 'download', status: 'error', deleteAfterShow: this.visor_params['deleteAfterShow'] });
                    break;
            }
        };
    }
    ngOnInit() {
        this.update();
        this.upload.getUpdateVisor().subscribe((data) => {
            this.update();
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            this.url = null;
            this.isImage = null;
            this.archive = yield this.file.getArchive(this.visor_params.archive.identifier);
            this.isImage = yield this.validateType(this.getExtension(this.archive), this.extensions_images);
            if (this.isImage) {
                this.loading = false;
                this.url = yield this.getUrl(this.archive, true);
            }
            else {
                this.url = yield this.getUrl(this.archive, true);
            }
            this.direct_download = false;
        });
    }
}
/** @nocollapse */ VisorGoogleComponent.ɵfac = function VisorGoogleComponent_Factory(t) { return new (t || VisorGoogleComponent)(ɵɵdirectiveInject(PathService), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(I18nPipe), ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(FileService)); };
/** @nocollapse */ VisorGoogleComponent.ɵcmp = ɵɵdefineComponent({ type: VisorGoogleComponent, selectors: [["akeela-visor-google"]], inputs: { filename: "filename", filedate: "filedate", filedownloadlink: "filedownloadlink", next: "next", back: "back", visor_params: ["visorparams", "visor_params"] }, outputs: { close: "close", eventaction: "eventaction" }, decls: 1, vars: 1, consts: [["class", "animated ModalLayer", "tabindex", "-1", 3, "zoomOut", "zoomIn", 4, "ngIf"], ["tabindex", "-1", 1, "animated", "ModalLayer"], [1, "AttachmentsCarousel--withThumbnails", "AttachmentsCarousel"], [1, "AttachmentMetadataBar"], [1, "AttachmentMetadataBar-left"], [1, "AttachmentMetadataBar-attachmentDetails"], [1, "AttachmentMetadataBar-attachmentName"], [1, "pr-3", "active-cursor", 3, "click"], [1, "fas", "fa-arrow-left"], ["class", "AttachmentMetadataBar-attachmentCreatedTime", 3, "innerHTML", 4, "ngIf"], [1, "AttachmentMetadataBar-attachmentButtons"], [4, "ngIf"], [1, "AttachmentsCarousel-carouselContainer"], [1, "Carousel--withOnImageButtons", "Carousel", "AttachmentsCarousel-carousel"], [1, "AttachmentsCarouselSlide", "Carousel-child", "AttachmentsCarousel-previewImage"], ["class", "load-bar", 4, "ngIf"], ["class", "Carousel-leftButtonContainer", 4, "ngIf"], [1, "AttachmentsCarousel-indexThumbnails"], [1, "AttachmentMetadataBar-attachmentCreatedTime", 3, "innerHTML"], ["class", "AttachmentMetadataBar-downloadLink active-cursor", 3, "disabled", "click", 4, "ngIf"], [1, "AttachmentMetadataBar-downloadLink", "active-cursor", 3, "click"], ["class", "fa fa-download", 4, "ngIf"], [1, "fa", "fa-download"], ["class", "fa fa-spinner fa-spin", 4, "ngIf"], [1, "d-none", "d-md-block"], [1, "fa", "fa-spinner", "fa-spin"], [1, "load-bar"], [1, "bar"], ["style", "width: 100%;height: 100%;border: 0", "frameBorder", "0", 3, "src", 4, "ngIf"], ["frameBorder", "0", 2, "width", "100%", "height", "100%", "border", "0", 3, "src"], [2, "width", "100%", "height", "100%", "display", "flex", "justify-content", "center", "align-items", "center", 3, "src"], [1, "Carousel-leftButtonContainer"], ["tabindex", "0", "role", "button", "aria-disabled", "false", 1, "CircularButton", "CircularButton--enabled", "CircularButton--medium", "CircularButton--circular", "Carousel-leftButton", 3, "click"], ["focusable", "false", "viewBox", "0 0 32 32", 1, "Icon", "LeftIcon"], ["d", "M8.8,16c0-0.3,0.1-0.7,0.3-0.9l9-11c0.5-0.6,1.5-0.7,2.1-0.2s0.7,1.5,0.2,2.1l-8.2,10l8.2,10c0.5,0.6,0.4,1.6-0.2,2.1s-1.6,0.4-2.1-0.2l-9-11C8.9,16.7,8.8,16.3,8.8,16z"], ["class", "Carousel-rightButtonContainer", 4, "ngIf"], [1, "Carousel-rightButtonContainer"], ["tabindex", "0", "role", "button", "aria-disabled", "false", 1, "CircularButton", "CircularButton--enabled", "CircularButton--medium", "CircularButton--circular", "Carousel-rightButton", 3, "click"], ["focusable", "false", "viewBox", "0 0 32 32", 1, "Icon", "RightIcon"], ["d", "M23.2,16c0,0.3-0.1,0.7-0.3,0.9l-9,11c-0.5,0.6-1.5,0.7-2.1,0.2s-0.7-1.5-0.2-2.1l8.2-10L11.6,6c-0.5-0.6-0.4-1.6,0.2-2.1s1.6-0.4,2.1,0.2l9,11C23.1,15.3,23.2,15.7,23.2,16z"]], template: function VisorGoogleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, VisorGoogleComponent_div_0_Template, 20, 11, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", !ctx.direct_download);
    } }, directives: [NgIf, ImageViewerComponent], pipes: [DatePipe], styles: [".ModalLayer[_ngcontent-%COMP%]{align-items:center;bottom:0;display:flex;flex-direction:column;left:0;position:fixed;right:0;top:0;z-index:10000}.Carousel-leftButtonContainer[_ngcontent-%COMP%]{left:15px}.Carousel-rightButtonContainer[_ngcontent-%COMP%]{right:15px}.Carousel-leftButtonContainer[_ngcontent-%COMP%], .Carousel-rightButtonContainer[_ngcontent-%COMP%]{align-items:center;cursor:pointer;display:flex;flex-direction:column;height:100%;justify-content:center;position:absolute;top:0;z-index:10331}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{filter:drop-shadow(0 1px 1px rgba(0,0,0,.3))}.CircularButton.CircularButton--medium[_ngcontent-%COMP%]{height:30px;width:30px}.Carousel-leftButton[_ngcontent-%COMP%], .Carousel-rightButton[_ngcontent-%COMP%]{box-shadow:0 5px 20px 0 rgba(21,27,38,.08)}.CircularButton--circular[_ngcontent-%COMP%]{background:#fff;border:1px solid #b7bfc6;border-radius:50%;box-sizing:border-box;color:#848f99;fill:#848f99;flex:0 0 auto;font-size:13px;height:30px;line-height:1;transition:box-shadow .2s,color .2s,background .2s,fill .2s,border-color .2s;width:30px}.CircularButton[_ngcontent-%COMP%]{align-items:center;display:inline-flex;justify-content:center}a[_ngcontent-%COMP%]{color:#14aaf5;cursor:pointer;text-decoration:none}.AttachmentMetadataBar[_ngcontent-%COMP%]{align-items:center;background:linear-gradient(180deg,#000 80%,transparent);color:#fff;display:flex;flex:0 0 auto;font-size:16px;font-weight:400;line-height:20px}.AttachmentsCarousel[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.65);display:flex;flex:1 1 auto;flex-direction:column;min-height:1px;min-width:1px;width:100%}.CloseButton[_ngcontent-%COMP%]{align-items:center;display:inline-flex;fill:#848f99}.AttachmentImageWithRotation[_ngcontent-%COMP%]{align-items:center;box-sizing:border-box;display:flex;flex-direction:column;height:100%;justify-content:center;position:relative;width:100%}.AttachmentImageWithRotation-image[_ngcontent-%COMP%]{background-color:#fff;flex:0 1 auto;max-height:100%;max-width:100%;min-height:1px;width:auto}.AttachmentsCarousel-previewImage.AttachmentsCarouselSlide[_ngcontent-%COMP%]{border-left-width:0;border-right-width:0}.AttachmentsCarouselSlide[_ngcontent-%COMP%]{background:rgba(0,0,0,.85);border:20px solid transparent}.Carousel-child[_ngcontent-%COMP%]{height:100%;left:0;position:absolute;top:0;width:100%}.AttachmentsCarouselPlaceholder-nonImagePlaceholder[_ngcontent-%COMP%]{align-items:center;color:#fff;display:flex;flex-direction:column}.AttachmentMetadataBar-left[_ngcontent-%COMP%]{align-items:center;display:flex;flex:1 1 auto;justify-content:space-between;min-width:1px}.AttachmentMetadataBar-attachmentDetails[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;flex-direction:column;margin-left:20px;margin-right:20px;min-width:1px}.AttachmentMetadataBar-attachmentName[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.AttachmentMetadataBar-attachmentCreatedTime[_ngcontent-%COMP%]{color:#848f99}.AttachmentMetadataBar-attachmentButtons[_ngcontent-%COMP%]{display:flex;flex-direction:row}.AttachmentMetadataBar-closeButton[_ngcontent-%COMP%]   .Icon[_ngcontent-%COMP%]{height:24px;width:24px}.AttachmentMetadataBar-closeButton[_ngcontent-%COMP%]{fill:#fff;opacity:.5}.AttachmentMetadataBar-annotateIcon[_ngcontent-%COMP%], .AttachmentMetadataBar-downloadIcon[_ngcontent-%COMP%]{flex:0 0 auto;margin-right:10px}.Icon[_ngcontent-%COMP%]{height:16px;width:16px}foreignObject[_ngcontent-%COMP%], image[_ngcontent-%COMP%], marker[_ngcontent-%COMP%], pattern[_ngcontent-%COMP%], svg[_ngcontent-%COMP%]:not(:root), symbol[_ngcontent-%COMP%], user[_ngcontent-%COMP%]   agent[_ngcontent-%COMP%]   stylesheet[_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]:not(:root){overflow:hidden}.Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-leftButton[_ngcontent-%COMP%], .Carousel--withOnImageButtons[_ngcontent-%COMP%]   .Carousel-rightButton[_ngcontent-%COMP%]{background:transparent;border-color:#fff;color:#fff;fill:#fff}.AttachmentMetadataBar-right[_ngcontent-%COMP%]{align-items:center;border-left:1px solid rgba(100,111,121,.4);display:flex;flex:0 0 auto;height:60px;justify-content:center;width:60px}.AttachmentsCarousel-carouselContainer[_ngcontent-%COMP%]{display:flex;flex:1 1 auto;flex-direction:row;min-height:1px}.AttachmentsCarousel-carousel[_ngcontent-%COMP%]{flex:1 1 auto;min-width:1px}.Carousel[_ngcontent-%COMP%]{overflow:hidden;position:relative;z-index:100}.AttachmentsCarousel-previewImage[_ngcontent-%COMP%]{border-left-width:0;border-right-width:0}.AttachmentsCarouselSlide[_ngcontent-%COMP%]{align-items:center;border:0 solid transparent;box-sizing:border-box;display:flex;flex-direction:column;justify-content:center}.AttachmentMetadataBar-downloadLink[_ngcontent-%COMP%], .AttachmentMetadataBar-openOriginalLink[_ngcontent-%COMP%], .AttachmentMetadataBar-proofingToggle[_ngcontent-%COMP%]{align-items:center;border-radius:4px;color:#fff;display:flex;fill:#fff;flex:0 0 auto;height:40px;margin-right:15px;padding:0 10px;white-space:nowrap}.container-noPreview[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.85);border-radius:12px;box-shadow:0 10px 12px 5px rgba(0,0,0,.2);color:#fff;margin-bottom:40px;padding:20px;text-align:center}.noPreview-title[_ngcontent-%COMP%]{-webkit-user-select:text;display:inline-block;font-size:19px;line-height:27px}.noPreview-download[_ngcontent-%COMP%]{margin-left:35px;margin-right:10px}.noPreview-download-button[_ngcontent-%COMP%]{background-color:#4d90fe;border:1px solid #4d90fe;border-radius:2px;box-shadow:inset 0 1px 0 hsla(0,0%,39.6%,.1);color:#fff;display:inline-block;font-size:11px;font-weight:700;height:28px;line-height:28px;margin-top:20px;min-width:54px;padding:0 20px 0 7px;text-align:center;text-shadow:0 1px 0 rgba(0,0,0,.8);vertical-align:middle;white-space:nowrap}.div-container[_ngcontent-%COMP%]{height:100%!important;min-height:100%!important}.div-child[_ngcontent-%COMP%]{height:auto;margin:0 auto;padding:10px;position:relative;width:auto}.load-bar[_ngcontent-%COMP%]{background-color:#fff;height:4px;position:relative;width:100%}.bar[_ngcontent-%COMP%]{content:\"\";display:inline;height:100%;left:50%;position:absolute;text-align:center;width:0}.bar[_ngcontent-%COMP%]:first-child{-webkit-animation:loading 3s linear infinite;animation:loading 3s linear infinite;background-color:#4fd3c4}.bar[_ngcontent-%COMP%]:nth-child(2){-webkit-animation:loading 3s linear 1s infinite;animation:loading 3s linear 1s infinite;background-color:#488fb1}.bar[_ngcontent-%COMP%]:nth-child(3){-webkit-animation:loading 3s linear 2s infinite;animation:loading 3s linear 2s infinite;background-color:#fff}@-webkit-keyframes loading{0%{left:0;width:0;z-index:100}33.3333%{left:0;width:100%;z-index:10}to{left:0;width:100%}}@keyframes loading{0%{left:0;width:0;z-index:100}33.3333%{left:0;width:100%;z-index:10}to{left:0;width:100%}}.embed-container[_ngcontent-%COMP%]{height:0;overflow:hidden;padding-bottom:56.25%;position:relative}.embed-container[_ngcontent-%COMP%]   iframe[_ngcontent-%COMP%]{height:100%;left:0;position:absolute;top:0;width:100%}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(VisorGoogleComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-visor-google',
                templateUrl: './visor.component.html',
                styleUrls: ['./visor.component.css']
            }]
    }], function () { return [{ type: PathService }, { type: UploadService }, { type: I18nPipe }, { type: DomSanitizer }, { type: FileService }]; }, { filename: [{
            type: Input
        }], filedate: [{
            type: Input
        }], filedownloadlink: [{
            type: Input
        }], next: [{
            type: Input
        }], back: [{
            type: Input
        }], visor_params: [{
            type: Input,
            args: ['visorparams']
        }], close: [{
            type: Output
        }], eventaction: [{
            type: Output
        }] }); })();

class viewPdfComponent {
    constructor(sanitizer, activatedRoute, router) {
        this.sanitizer = sanitizer;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.url = null;
    }
    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params.url) {
                this.url = this.sanitizer.bypassSecurityTrustResourceUrl(params.url);
            }
        });
    }
}
/** @nocollapse */ viewPdfComponent.ɵfac = function viewPdfComponent_Factory(t) { return new (t || viewPdfComponent)(ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router)); };
/** @nocollapse */ viewPdfComponent.ɵcmp = ɵɵdefineComponent({ type: viewPdfComponent, selectors: [["akeela-view-pdf"]], decls: 5, vars: 2, consts: [["width", "100%", "height", "100%", "type", "application/pdf", 2, "position", "fixed", 3, "data"], ["target", "_blank", 3, "href"]], template: function viewPdfComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "object", 0);
        ɵɵelementStart(1, "p");
        ɵɵtext(2, "Sorry, the PDF couldn't be displayed :(");
        ɵɵelementEnd();
        ɵɵelementStart(3, "a", 1);
        ɵɵtext(4, "Click Here");
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("data", ctx.url, ɵɵsanitizeResourceUrl);
        ɵɵadvance(3);
        ɵɵproperty("href", ctx.url, ɵɵsanitizeUrl);
    } }, styles: ["#outerContainer[_ngcontent-%COMP%]   #mainContainer[_ngcontent-%COMP%]   div.toolbar[_ngcontent-%COMP%]{display:none!important}#outerContainer[_ngcontent-%COMP%]   #mainContainer[_ngcontent-%COMP%]   #viewerContainer[_ngcontent-%COMP%]{top:0!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(viewPdfComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-view-pdf',
                templateUrl: './view-pdf.component.html',
                styleUrls: ['./view-pdf.component.css']
            }]
    }], function () { return [{ type: DomSanitizer }, { type: ActivatedRoute }, { type: Router }]; }, null); })();

class LineLoadingComponent {
    constructor() { }
    ngOnInit() {
    }
}
/** @nocollapse */ LineLoadingComponent.ɵfac = function LineLoadingComponent_Factory(t) { return new (t || LineLoadingComponent)(); };
/** @nocollapse */ LineLoadingComponent.ɵcmp = ɵɵdefineComponent({ type: LineLoadingComponent, selectors: [["akeela-line-loading"]], decls: 2, vars: 0, consts: [[1, "loader"], [1, "bar"]], template: function LineLoadingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelement(1, "div", 1);
        ɵɵelementEnd();
    } }, styles: ["@-webkit-keyframes loader-animation{0%{left:-100%}49%{left:100%}50%{left:100%}to{left:-100%}}@keyframes loader-animation{0%{left:-100%}49%{left:100%}50%{left:100%}to{left:-100%}}.loader[_ngcontent-%COMP%]{height:3px;overflow:hidden;width:100%}.loader[_ngcontent-%COMP%]   .bar[_ngcontent-%COMP%]{-webkit-animation-duration:3s;-webkit-animation-iteration-count:infinite;-webkit-animation-name:loader-animation;-webkit-animation-timing-function:ease-in-out;animation-duration:3s;animation-iteration-count:infinite;animation-name:loader-animation;animation-timing-function:ease-in-out;background-color:var(--ak-color-2)!important;height:5px;position:relative;width:100%}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LineLoadingComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-line-loading',
                templateUrl: './line-loading.component.html',
                styleUrls: ['./line-loading.component.css']
            }]
    }], function () { return []; }, null); })();

function PaginatorComponent_ng_container_0_nav_1_ng_container_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "li", 7);
    ɵɵelementStart(2, "a", 12);
    ɵɵlistener("click", function PaginatorComponent_ng_container_0_nav_1_ng_container_8_ng_container_1_Template_a_click_2_listener() { ɵɵrestoreView(_r7); const number_r5 = ctx.$implicit; const ctx_r6 = ɵɵnextContext(4); return ctx_r6.goto("PAGE", number_r5); });
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const number_r5 = ctx.$implicit;
    const ctx_r4 = ɵɵnextContext(4);
    ɵɵadvance(1);
    ɵɵclassProp("active", ctx_r4._paginator.pageable.pageNumber === number_r5);
    ɵɵadvance(2);
    ɵɵtextInterpolate(number_r5 + 1);
} }
function PaginatorComponent_ng_container_0_nav_1_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PaginatorComponent_ng_container_0_nav_1_ng_container_8_ng_container_1_Template, 4, 3, "ng-container", 11);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(3);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r3.items);
} }
function PaginatorComponent_ng_container_0_nav_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "nav", 3);
    ɵɵelementStart(1, "ul", 4);
    ɵɵelementStart(2, "li", 5);
    ɵɵelementStart(3, "a", 6);
    ɵɵlistener("click", function PaginatorComponent_ng_container_0_nav_1_Template_a_click_3_listener() { ɵɵrestoreView(_r9); const ctx_r8 = ɵɵnextContext(2); return ctx_r8.goto("FIRST"); });
    ɵɵtext(4, " <<");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "li", 7);
    ɵɵelementStart(6, "a", 8);
    ɵɵlistener("click", function PaginatorComponent_ng_container_0_nav_1_Template_a_click_6_listener() { ɵɵrestoreView(_r9); const ctx_r10 = ɵɵnextContext(2); return ctx_r10.goto("BACK"); });
    ɵɵtext(7, " <");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵtemplate(8, PaginatorComponent_ng_container_0_nav_1_ng_container_8_Template, 2, 1, "ng-container", 0);
    ɵɵelementStart(9, "li", 7);
    ɵɵelementStart(10, "a", 9);
    ɵɵlistener("click", function PaginatorComponent_ng_container_0_nav_1_Template_a_click_10_listener() { ɵɵrestoreView(_r9); const ctx_r11 = ɵɵnextContext(2); return ctx_r11.goto("NEXT"); });
    ɵɵtext(11, ">");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(12, "li", 5);
    ɵɵelementStart(13, "a", 10);
    ɵɵlistener("click", function PaginatorComponent_ng_container_0_nav_1_Template_a_click_13_listener() { ɵɵrestoreView(_r9); const ctx_r12 = ɵɵnextContext(2); return ctx_r12.goto("LAST"); });
    ɵɵtext(14, ">>");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext(2);
    ɵɵadvance(2);
    ɵɵclassProp("disabled", ctx_r1._paginator.first);
    ɵɵadvance(3);
    ɵɵclassProp("disabled", ctx_r1._paginator.first);
    ɵɵadvance(3);
    ɵɵproperty("ngIf", ctx_r1.items);
    ɵɵadvance(1);
    ɵɵclassProp("disabled", ctx_r1._paginator.last);
    ɵɵadvance(3);
    ɵɵclassProp("disabled", ctx_r1._paginator.last);
} }
function PaginatorComponent_ng_container_0_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 13);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", "P\u00E1gina " + (ctx_r2._paginator.pageable.pageNumber + 1) + " de " + ctx_r2._paginator.totalPages, " ");
} }
function PaginatorComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PaginatorComponent_ng_container_0_nav_1_Template, 15, 9, "nav", 1);
    ɵɵtemplate(2, PaginatorComponent_ng_container_0_div_2_Template, 2, 1, "div", 2);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0._paginator.totalPages > 1);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0._paginator.totalPages > 1);
} }
class PaginatorComponent {
    constructor() {
        this.response = new EventEmitter();
        // lodash = merge;
        this.items = [];
    }
    set paginator(value) {
        this._paginator = value;
        this.generatePagesByActive();
    }
    ngOnInit() {
        this.generatePagesByActive();
    }
    generatePagesByActive() {
        this.items = [];
        if (this._paginator.totalPages >= 7) {
            if (this._paginator.pageable.pageNumber >= 4 && this._paginator.pageable.pageNumber <= (this._paginator.totalPages - 4)) {
                for (let i = (this._paginator.pageable.pageNumber - 3); i < (this._paginator.pageable.pageNumber + 4); i++) {
                    this.items.push(i);
                }
            }
            else {
                if (this._paginator.pageable.pageNumber < 4) {
                    for (let i = 0; i < 7; i++) {
                        this.items.push(i);
                    }
                }
                else {
                    for (let i = (this._paginator.totalPages - 7); i < this._paginator.totalPages; i++) {
                        this.items.push(i);
                    }
                }
            }
        }
        else {
            for (let i = 0; i < this._paginator.totalPages; i++) {
                this.items.push(i);
            }
        }
    }
    goto(action, number) {
        console.log(action);
        if (action === 'PAGE') {
            this._paginator.pageable.pageNumber = number;
        }
        else if (action === 'BACK') {
            this._paginator.pageable.pageNumber = (this._paginator.pageable.pageNumber - 1);
        }
        else if (action === 'NEXT') {
            this._paginator.pageable.pageNumber = (this._paginator.pageable.pageNumber + 1);
        }
        else if (action === 'LAST') {
            this._paginator.last = true;
            this._paginator.first = false;
            this._paginator.pageable.pageNumber = (this._paginator.totalPages - 1);
        }
        else if (action === 'FIRST') {
            this._paginator.last = false;
            this._paginator.first = true;
            this._paginator.pageable.pageNumber = 0;
        }
        this.generatePagesByActive();
        this.response.emit(this._paginator.pageable.pageNumber);
    }
}
/** @nocollapse */ PaginatorComponent.ɵfac = function PaginatorComponent_Factory(t) { return new (t || PaginatorComponent)(); };
/** @nocollapse */ PaginatorComponent.ɵcmp = ɵɵdefineComponent({ type: PaginatorComponent, selectors: [["akeela-paginator"]], inputs: { paginator: "paginator" }, outputs: { response: "response" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["aria-label", "Page navigation example", 4, "ngIf"], ["class", "w-100 text-center font-weight-bold", 4, "ngIf"], ["aria-label", "Page navigation example"], [1, "pagination"], [1, "page-item", "d-none", "d-md-block"], ["href", "javascript:void()", "title", "Primera P\u00E1gina", 1, "page-link", 3, "click"], [1, "page-item"], ["href", "javascript:void()", "title", "Anterior", 1, "page-link", 3, "click"], ["href", "javascript:void()", "title", "Siguiente", 1, "page-link", 3, "click"], ["href", "javascript:void()", "title", "\u00DAltima P\u00E1gina", 1, "page-link", 3, "click"], [4, "ngFor", "ngForOf"], ["href", "javascript:void()", 1, "page-link", 3, "click"], [1, "w-100", "text-center", "font-weight-bold"]], template: function PaginatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, PaginatorComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx._paginator);
    } }, directives: [NgIf, NgForOf], styles: [".page-link[_ngcontent-%COMP%]{border-color:var(--ak-color-3)!important;color:var(--ak-breadcrumb-color)!important}.page-item.active[_ngcontent-%COMP%]   .page-link[_ngcontent-%COMP%]{background-color:var(--ak-breadcrumb-color)!important;border-color:var(--ak-breadcrumb-color)!important;color:#fff!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PaginatorComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-paginator',
                templateUrl: './paginator.component.html',
                styleUrls: ['./paginator.component.css']
            }]
    }], function () { return []; }, { response: [{
            type: Output
        }], paginator: [{
            type: Input
        }] }); })();

class CustomDatePipe {
    constructor(_date) {
        this._date = _date;
    }
    transform(value, args) {
        let format = 'd MMM, h:mm a';
        let currentdate = this._date.transform(Date.now(), 'M/d/yy');
        let indate = this._date.transform(value, 'M/d/yy');
        if (value != null) {
            if (value.trim() != '') {
                if (currentdate === indate) {
                    format = 'h:mm a';
                }
                else if (this._date.transform(Date.now(), 'yy') !== this._date.transform((value), 'yy')) {
                    format = 'd MMM, y';
                }
            }
        }
        return this._date.transform(value, format); //h:mm a
    }
}
/** @nocollapse */ CustomDatePipe.ɵfac = function CustomDatePipe_Factory(t) { return new (t || CustomDatePipe)(ɵɵdirectiveInject(DatePipe)); };
/** @nocollapse */ CustomDatePipe.ɵpipe = ɵɵdefinePipe({ name: "customdate", type: CustomDatePipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CustomDatePipe, [{
        type: Pipe,
        args: [{
                name: 'customdate'
            }]
    }], function () { return [{ type: DatePipe }]; }, null); })();

class FormatPipe {
    constructor(_i18n) {
        this._i18n = _i18n;
        this.months = [
            '',
            '@i18n-month-january',
            '@i18n-month-february',
            '@i18n-month-march',
            '@i18n-month-april',
            '@i18n-month-may',
            '@i18n-month-june',
            '@i18n-month-july',
            '@i18n-month-august',
            '@i18n-month-september',
            '@i18n-month-october',
            '@i18n-month-november',
            '@i18n-month-december'
        ];
    }
    transform(val) {
        let aux = val.split(',');
        let concat = '';
        if (aux.length === 2) {
            concat = this._i18n.transform(this.months[(aux[0])]).substring(0, 3).toUpperCase() + ',' + aux[1];
            val = concat;
        }
        return val;
    }
}
/** @nocollapse */ FormatPipe.ɵfac = function FormatPipe_Factory(t) { return new (t || FormatPipe)(ɵɵdirectiveInject(I18nPipe)); };
/** @nocollapse */ FormatPipe.ɵpipe = ɵɵdefinePipe({ name: "format", type: FormatPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FormatPipe, [{
        type: Pipe,
        args: [{
                name: 'format'
            }]
    }], function () { return [{ type: I18nPipe }]; }, null); })();

class WebcamService {
    constructor() {
        // webcam snapshot trigger
        this.trigger = new Subject();
        // webcam captured image
        this.image = new Subject();
        // webcam show
        this.show = new Subject();
        // webcam show
        this.uploadFile = new Subject();
    }
    triggerSnapshot() {
        this.trigger.next();
    }
    get triggerObservable() {
        return this.trigger.asObservable();
    }
    executeUploadFile() {
        this.uploadFile.next();
    }
    get executeUploadFileObservable() {
        return this.uploadFile.asObservable();
    }
    setImage(image) {
        this.image.next(image);
    }
    get imageObservable() {
        return this.image.asObservable();
    }
    setToggleWebcam() {
        this.show.next();
    }
    get toggleObservable() {
        return this.show.asObservable();
    }
}
/** @nocollapse */ WebcamService.ɵfac = function WebcamService_Factory(t) { return new (t || WebcamService)(); };
/** @nocollapse */ WebcamService.ɵprov = ɵɵdefineInjectable({ token: WebcamService, factory: WebcamService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(WebcamService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function WebcamComponent_webcam_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "webcam", 2);
    ɵɵlistener("imageCapture", function WebcamComponent_webcam_0_Template_webcam_imageCapture_0_listener($event) { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.handleImage($event); })("cameraSwitched", function WebcamComponent_webcam_0_Template_webcam_cameraSwitched_0_listener($event) { ɵɵrestoreView(_r3); const ctx_r4 = ɵɵnextContext(); return ctx_r4.cameraWasSwitched($event); })("initError", function WebcamComponent_webcam_0_Template_webcam_initError_0_listener($event) { ɵɵrestoreView(_r3); const ctx_r5 = ɵɵnextContext(); return ctx_r5.handleInitError($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("height", ctx_r0._config.height)("width", ctx_r0._config.width)("trigger", ctx_r0.triggerObservable)("allowCameraSwitch", ctx_r0.allowCameraSwitch)("switchCamera", true)("videoOptions", ctx_r0.videoOptions)("imageQuality", 0.92)("mirrorImage", "auto");
} }
function WebcamComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 3);
    ɵɵelement(1, "img", 4);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("src", ctx_r1.webcamImage, ɵɵsanitizeUrl)("width", ctx_r1._config.width)("height", "351");
} }
class WebcamComponent {
    constructor(webcamService, localStorage) {
        this.webcamService = webcamService;
        this.localStorage = localStorage;
        this.suscriptions = new Subscription();
        this.response = new EventEmitter();
        // toggle webcam on/off
        this.showWebcam = true;
        this.allowCameraSwitch = true;
        this.multipleWebcamsAvailable = false;
        this.facingMode = 'user';
        this.messages = [];
        // latest snapshot
        this.webcamImage = null;
        // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
        //public  nextWebcam: BehaviorSubject<any> = new BehaviorSubject<boolean | string>(true);
        this.nextWebcam = new Subject();
        this.validateAttempt = () => {
            var _a, _b;
            if (!isNullOrUndefined((_a = this._config.facialRecognition) === null || _a === void 0 ? void 0 : _a.maxAttempt)) {
                if (this.localStorage.getItem('currentAttemp') > ((_b = this._config.facialRecognition) === null || _b === void 0 ? void 0 : _b.maxAttempt)) {
                    return true;
                }
                else {
                    return false;
                }
            }
            return false;
        };
    }
    set config(value) {
        this._config = value;
    }
    set faceChecked(value) {
        if (!isNullOrUndefined(value) && !isNullOrUndefined(this.webcamImage)) {
            this.webcamService.setImage(this.webcamImage);
            this.webcamImage = null;
        }
    }
    ngOnInit() {
        this.suscriptions.add(this.webcamService.imageObservable.subscribe((image) => {
            this.webcamImage = image;
        }));
        this.suscriptions.add(this.webcamService.toggleObservable.subscribe((show) => {
            this.showWebcam = !this.showWebcam;
        }));
    }
    handleImage(webcamImage) {
        console.log(webcamImage.imageAsDataUrl);
        //if (this._config ?.facialRecognition ?.active && !this.validateAttempt()) {
        this.response.emit({
            'type': 'previewB64',
            'image': webcamImage.imageAsDataUrl
        });
        // } else {
        //   this.webcamService.setImage(webcamImage);
        // }
    }
    get triggerObservable() {
        return this.webcamService.triggerObservable;
    }
    get nextWebcamObservable() {
        return this.nextWebcam.asObservable();
    }
    get videoOptions() {
        const result = {};
        if (this.facingMode && this.facingMode !== '') {
            result.facingMode = { ideal: this.facingMode };
        }
        return result;
    }
    addMessage(message) {
        this.messages.unshift(message);
    }
    cameraWasSwitched(deviceId) {
        this.addMessage('Active device: ' + deviceId);
        this.deviceId = deviceId;
        this.readAvailableVideoInputs();
    }
    handleInitError(error) {
        this.messages.push(error);
        if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
            this.addMessage('User denied camera access');
        }
    }
    readAvailableVideoInputs() {
        WebcamUtil.getAvailableVideoInputs()
            .then((mediaDevices) => {
            this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        });
    }
    ngOnDestroy() {
        if (!isNullOrUndefined(this.suscriptions)) {
            this.suscriptions.unsubscribe();
        }
    }
}
/** @nocollapse */ WebcamComponent.ɵfac = function WebcamComponent_Factory(t) { return new (t || WebcamComponent)(ɵɵdirectiveInject(WebcamService), ɵɵdirectiveInject(LocalService)); };
/** @nocollapse */ WebcamComponent.ɵcmp = ɵɵdefineComponent({ type: WebcamComponent, selectors: [["akeela-webcam"]], inputs: { config: "config", faceChecked: "faceChecked" }, outputs: { response: "response" }, decls: 2, vars: 2, consts: [[3, "height", "width", "trigger", "allowCameraSwitch", "switchCamera", "videoOptions", "imageQuality", "mirrorImage", "imageCapture", "cameraSwitched", "initError", 4, "ngIf"], ["class", "snapshot", 4, "ngIf"], [3, "height", "width", "trigger", "allowCameraSwitch", "switchCamera", "videoOptions", "imageQuality", "mirrorImage", "imageCapture", "cameraSwitched", "initError"], [1, "snapshot"], ["alt", "webcam image", 3, "src", "width", "height"]], template: function WebcamComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, WebcamComponent_webcam_0_Template, 1, 8, "webcam", 0);
        ɵɵtemplate(1, WebcamComponent_div_1_Template, 2, 3, "div", 1);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.showWebcam && !ctx.webcamImage);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.webcamImage);
    } }, directives: [NgIf, WebcamComponent$1], styles: [".webcam-wrapper[_ngcontent-%COMP%]   video[_ngcontent-%COMP%]{max-height:480px;max-width:480px}@media (max-width:576px){.webcam-wrapper[_ngcontent-%COMP%]   video[_ngcontent-%COMP%]{max-height:80%;max-width:80%}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(WebcamComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-webcam',
                templateUrl: './webcam.component.html',
                styleUrls: ['./webcam.component.css']
            }]
    }], function () { return [{ type: WebcamService }, { type: LocalService }]; }, { config: [{
            type: Input
        }], faceChecked: [{
            type: Input
        }], response: [{
            type: Output
        }] }); })();

function WebcamButtonsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementContainerStart(1);
    ɵɵelementStart(2, "div", 1);
    ɵɵelementStart(3, "div", 2);
    ɵɵelementStart(4, "button", 3);
    ɵɵlistener("click", function WebcamButtonsComponent_ng_container_0_Template_button_click_4_listener() { ɵɵrestoreView(_r2); const ctx_r1 = ɵɵnextContext(); return ctx_r1.triggerSnapshot(); });
    ɵɵelement(5, "i", 4);
    ɵɵtext(6, " Tomar foto");
    ɵɵelementEnd();
    ɵɵelement(7, "br");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(8, "div", 1);
    ɵɵelementStart(9, "div", 2);
    ɵɵelementStart(10, "a", 5);
    ɵɵlistener("click", function WebcamButtonsComponent_ng_container_0_Template_a_click_10_listener() { ɵɵrestoreView(_r2); const ctx_r3 = ɵɵnextContext(); return ctx_r3.close_window(); });
    ɵɵtext(11, " Salir");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
    ɵɵelementContainerEnd();
} }
class WebcamButtonsComponent {
    constructor(webcamService, uploader) {
        this.webcamService = webcamService;
        this.uploader = uploader;
        // toggle webcam on/off
        this.showWebcam = true;
        // webcam snapshot trigger
        this.trigger = new Subject();
        // latest snapshot
        this.webcamImage = null;
        this.subcriptions = new Subscription;
        this.finish = false;
        this.close = new EventEmitter();
        this.close_window = () => {
            this.close.emit(true);
        };
    }
    set config(value) {
        this._config = value;
    }
    set identifier(value) {
        this._identifier = value;
    }
    ngOnInit() {
        this.subcriptions.add(this.webcamService.imageObservable.subscribe((image) => {
            this.webcamImage = image;
            if (isNullOrUndefined(image)) {
                this.finish = false;
            }
            else {
                // this.upload();
            }
        }));
        this.subcriptions.add(this.webcamService.executeUploadFileObservable.subscribe((resp) => {
            // FIND: MARIO
            this.upload();
        }));
    }
    triggerSnapshot() {
        this.webcamService.triggerSnapshot();
    }
    toggleWebcam() {
        this.showWebcam = !this.showWebcam;
        this.webcamService.setToggleWebcam();
    }
    cancel() {
        this.webcamImage = null;
        this.finish = false;
        this.webcamService.setImage(null);
    }
    upload() {
        this.finish = false;
        const date_now = Date.now();
        // this.webcamImage.imageAsDataUrl
        const form = this.dataUriToFormData(this.webcamImage, { fileName: this._identifier + date_now + '.png' });
        this.subcriptions.add(this.uploader.postFile(form, this._identifier, this._config.viewName, true).subscribe((data) => {
            this.finish = true;
        }, error => {
            this.finish = false;
            // this.response.emit({ type: 'error', title: 'Error', html: 'Error subiendo el archivo.' });
        }));
    }
    dataUriToFormData(dataURI, options) {
        // const byteString: any = this.dataUriToBlob(dataURI);
        options = options || {};
        options.form = options.form || new FormData();
        options.form.append('file', this.dataURItoBlob(dataURI), options.fileName || 'file.png');
        return options.form;
    }
    // dataUriToBlob(dataURI): any {
    //   // convert base64/URLEncoded data component to raw binary data held in a string
    //   let byteString;
    //   if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    //     byteString = atob(dataURI.split(',')[1]);
    //   } else {
    //     byteString = window['unescape'](dataURI.split(',')[1]);
    //   }
    // }
    dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        let byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
        }
        else {
            byteString = unescape(dataURI.split(',')[1]);
        }
        // separate out the mime component
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to a typed array
        const ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], { type: mimeString });
    }
    ngOnDestroy() {
        if (!isNullOrUndefined(this.subcriptions)) {
            this.subcriptions.unsubscribe();
        }
    }
}
/** @nocollapse */ WebcamButtonsComponent.ɵfac = function WebcamButtonsComponent_Factory(t) { return new (t || WebcamButtonsComponent)(ɵɵdirectiveInject(WebcamService), ɵɵdirectiveInject(UploadService)); };
/** @nocollapse */ WebcamButtonsComponent.ɵcmp = ɵɵdefineComponent({ type: WebcamButtonsComponent, selectors: [["akeela-webcam-buttons"]], inputs: { config: "config", identifier: "identifier" }, outputs: { close: "close" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "row"], [1, "col-12"], [1, "btn", "btn-primary", "btn-block", 3, "click"], [1, "fas", "fa-camera"], ["href", "javascript:void()", 3, "click"]], template: function WebcamButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, WebcamButtonsComponent_ng_container_0_Template, 12, 0, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.showWebcam);
    } }, directives: [NgIf], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(WebcamButtonsComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-webcam-buttons',
                templateUrl: './webcam-buttons.component.html',
                styleUrls: ['./webcam-buttons.component.css']
            }]
    }], function () { return [{ type: WebcamService }, { type: UploadService }]; }, { config: [{
            type: Input
        }], identifier: [{
            type: Input
        }], close: [{
            type: Output
        }] }); })();

function PreviewDocComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵɵgetCurrentView();
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "ngx-doc-viewer", 1);
    ɵɵlistener("loaded", function PreviewDocComponent_ng_container_0_ng_container_1_Template_ngx_doc_viewer_loaded_1_listener($event) { ɵɵrestoreView(_r4); const ctx_r3 = ɵɵnextContext(2); return ctx_r3.response_visor($event); });
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("disableContent", "all")("viewerUrl", ctx_r1.viewerUrl)("url", ctx_r1.url);
} }
const _c0$1 = function (a0) { return [a0]; };
function PreviewDocComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "ngx-image-viewer", 2);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("src", ɵɵpureFunction1(1, _c0$1, ctx_r2.url));
} }
function PreviewDocComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, PreviewDocComponent_ng_container_0_ng_container_1_Template, 2, 3, "ng-container", 0);
    ɵɵtemplate(2, PreviewDocComponent_ng_container_0_ng_container_2_Template, 2, 3, "ng-container", 0);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", !ctx_r0.isImage && ctx_r0.url);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.isImage && ctx_r0.url);
} }
class PreviewDocComponent {
    constructor(_path, upload, sanitizer, file) {
        this._path = _path;
        this.upload = upload;
        this.sanitizer = sanitizer;
        this.file = file;
        this.eventaction = new EventEmitter();
        this.suscriptor = new Subscription();
        this.direct_download = true;
        this.url = null;
        this.loading = true;
        this.archive = null;
        this.extensions_google_visor = ['.ppt', '.pptx', '.doc', '.docx', '.xls', '.xlsx', '.pdf'];
        this.extensions_images = ['.jpg', '.jpeg', '.png', '.gift', '.svg'];
        this.isImage = null;
        this.viewerUrl = 'https://docs.google.com/gview?url=%URL%&embedded=true';
        this.getExtension = (archive) => {
            return (archive.name.substring(archive.name.lastIndexOf('.'))).toLowerCase();
        };
        this.validateType = (ext, extensions_enabled) => {
            return extensions_enabled.includes(ext);
        };
        this.getUrl = (archive, sanitize) => __awaiter(this, void 0, void 0, function* () {
            const endpoint = yield this.getEndpointByKey('archive$downloadFile$get');
            if (!isNullOrUndefined(sanitize)) {
                if (sanitize) {
                    return this.sanitizer.bypassSecurityTrustResourceUrl(`${endpoint.url}?idArchive=${archive.identifier}&contentDisposition=inline`);
                }
                else {
                    return `${endpoint.url}?idArchive=${archive.identifier}&contentDisposition=inline`;
                }
            }
            else {
                return `${endpoint.url}?idArchive=${archive.identifier}&contentDisposition=inline`;
            }
        });
        this.getEndpointByKey = (endpoint) => __awaiter(this, void 0, void 0, function* () {
            return yield this._path.getPathService(endpoint).toPromise();
        });
        this.response_visor = (response) => {
            if (response) {
                this.loading = false;
            }
        };
    }
    ngOnInit() {
        this.update();
        this.suscriptor.add(this.upload.getUpdateVisor().subscribe((data) => {
            this.update();
        }));
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            console.log('mando a hacer update');
            this.url = null;
            this.isImage = null;
            this.archive = yield this.file.getArchive(this.identifier);
            this.isImage = yield this.validateType(this.getExtension(this.archive), this.extensions_images);
            if (this.isImage) {
                this.loading = false;
                this.url = yield this.getUrl(this.archive, true);
            }
            else {
                this.response_visor(true);
                this.url = yield this.getUrl(this.archive);
            }
            this.direct_download = false;
        });
    }
    ngOnDestroy() {
        if (!isNullOrUndefined(this.suscriptor)) {
            this.suscriptor.unsubscribe();
        }
    }
}
/** @nocollapse */ PreviewDocComponent.ɵfac = function PreviewDocComponent_Factory(t) { return new (t || PreviewDocComponent)(ɵɵdirectiveInject(PathService), ɵɵdirectiveInject(UploadService), ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(FileService)); };
/** @nocollapse */ PreviewDocComponent.ɵcmp = ɵɵdefineComponent({ type: PreviewDocComponent, selectors: [["akeela-preview-doc"]], inputs: { identifier: "identifier" }, outputs: { eventaction: "eventaction" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["googleCheckContentLoaded", "true", "googleCheckInterval", "3000", "googleMaxChecks", "5", 2, "width", "100%", "height", "100%", 3, "disableContent", "viewerUrl", "url", "loaded"], [2, "width", "100%", "height", "100%", "display", "flex", "justify-content", "center", "align-items", "center", 3, "src"]], template: function PreviewDocComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, PreviewDocComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.archive && ctx.isImage !== null);
    } }, directives: [NgIf, NgxDocViewerComponent, ImageViewerComponent], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PreviewDocComponent, [{
        type: Component,
        args: [{
                selector: 'akeela-preview-doc',
                templateUrl: './preview-doc.component.html',
                styleUrls: ['./preview-doc.component.css']
            }]
    }], function () { return [{ type: PathService }, { type: UploadService }, { type: DomSanitizer }, { type: FileService }]; }, { identifier: [{
            type: Input
        }], eventaction: [{
            type: Output
        }] }); })();

class AkeelaCommonModule {
}
/** @nocollapse */ AkeelaCommonModule.ɵmod = ɵɵdefineNgModule({ type: AkeelaCommonModule, bootstrap: [VisorComponent,
        VisorGoogleComponent,
        viewPdfComponent,
        LineLoadingComponent,
        PaginatorComponent] });
/** @nocollapse */ AkeelaCommonModule.ɵinj = ɵɵdefineInjector({ factory: function AkeelaCommonModule_Factory(t) { return new (t || AkeelaCommonModule)(); }, providers: [
        CommonService,
        I18nService,
        VisorService,
        FileService,
        CreditService,
        CountdownService,
        UploadService,
        ErrorService,
        UtilsService,
        PaginatorService
    ], imports: [[
            CommonModule,
            I18nModule,
            WebcamModule,
            NgxDocViewerModule,
            ImageViewerModule.forRoot()
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AkeelaCommonModule, { declarations: [CustomDatePipe,
        FormatPipe,
        VisorComponent,
        VisorGoogleComponent,
        viewPdfComponent,
        LineLoadingComponent,
        PaginatorComponent,
        WebcamComponent,
        WebcamButtonsComponent,
        PreviewDocComponent], imports: [CommonModule,
        I18nModule,
        WebcamModule,
        NgxDocViewerModule, ImageViewerModule], exports: [VisorComponent,
        VisorGoogleComponent,
        viewPdfComponent,
        LineLoadingComponent,
        PaginatorComponent,
        WebcamComponent,
        WebcamButtonsComponent,
        PreviewDocComponent,
        CustomDatePipe] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AkeelaCommonModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    I18nModule,
                    WebcamModule,
                    NgxDocViewerModule,
                    ImageViewerModule.forRoot()
                ],
                declarations: [
                    CustomDatePipe,
                    FormatPipe,
                    VisorComponent,
                    VisorGoogleComponent,
                    viewPdfComponent,
                    LineLoadingComponent,
                    PaginatorComponent,
                    WebcamComponent,
                    WebcamButtonsComponent,
                    PreviewDocComponent
                ],
                providers: [
                    CommonService,
                    I18nService,
                    VisorService,
                    FileService,
                    CreditService,
                    CountdownService,
                    UploadService,
                    ErrorService,
                    UtilsService,
                    PaginatorService
                ],
                exports: [
                    VisorComponent,
                    VisorGoogleComponent,
                    viewPdfComponent,
                    LineLoadingComponent,
                    PaginatorComponent,
                    WebcamComponent,
                    WebcamButtonsComponent,
                    PreviewDocComponent,
                    CustomDatePipe
                ],
                bootstrap: [
                    VisorComponent,
                    VisorGoogleComponent,
                    viewPdfComponent,
                    LineLoadingComponent,
                    PaginatorComponent
                ]
            }]
    }], null, null); })();

class TabsService {
    constructor() {
        this.config$ = new BehaviorSubject(null);
    }
}
/** @nocollapse */ TabsService.ɵfac = function TabsService_Factory(t) { return new (t || TabsService)(); };
/** @nocollapse */ TabsService.ɵprov = ɵɵdefineInjectable({ token: TabsService, factory: TabsService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TabsService, [{
        type: Injectable
    }], function () { return []; }, null); })();

/*
 * Public API Surface of common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AkeelaCommonModule, CommonService, CountdownService, CreditService, CustomDatePipe, ErrorService, FileService, I18nService, LineLoadingComponent, PaginatorComponent, PaginatorService, PreviewDocComponent, TabsService, UploadService, UtilsService, VisorComponent, VisorGoogleComponent, VisorService, WebcamButtonsComponent, WebcamComponent, WebcamService, viewPdfComponent };
//# sourceMappingURL=akeela-common.js.map
